const pl = {
	translation: {
		errors: {
			emptySingleField: "Pole nie może być puste",
			emptyUserName: "Pole login nie może zostać puste.",
			passwordToShort: "Minimalna długość hasła to 8 znaków",
			wrongPasswordOrLogin: "Błędny login lub hasło",
			emptyField: "Wszystkie pola muszą być uzupełnione",
			passwordsNotTheSame: "Wprowadzone hasła nie pasują do siebie",
			wrongEmailFormat: "Podaj poprawny format adresu email",
			usernameExists: "Ta nazwa użytkownika jest już zajęta",
			emailExists: "Ten email jest już zajęty",
			requiredField: "To pole jest wymagane",
			somethingWentWrong:
				"Coś poszło nie tak, prosimy spróbuj ponownie później.",
			cannotGetExam:
				"Wystąpił problem przy pobieraniu egzaminu. Spróbuj ponownie później. Jeżeli problem będzie się ponawiał prosimy o kontakt z naszym zespołem.",
			maxCountOfQuestions:
				"Maksymalna ilość pytań w jednym egzaminie to: {{count}}",
			emptyWrongAnswersInCourse:
				"Brak błędnie rozwiązanych pytań w tym kursie.",
			toManyQuestionsInExamCourse:
				'Maksymalna ilość pytań w jednym egzaminie to: {{maxQuestions}}. Skorzystaj z opcji "Wygeneruj kurs z błędnych odpowiedzi".',
			emptyFieldText: "Wszystkie pola muszą być uzupełnione",
			emptyFlashcards: "Uzupełnij przód i tył fiszki aby dodać ją do zestawu",
			passwordsNotTheSameText: "Wprowadzone hasła nie pasują do siebie",
			wrongOldPassword: "Wprowadzone stare hasło jest niepoprawne",
			sessionHasExpired:
				"Twoja sesja wygasła. Zaloguj się ponownie do serwisu.",
			editPrivateFlashcards:
				"Ta fiszka pochodzi z innego zestawu. Nie można jej edytować.",
			emptyDeck: "Nie ma żadnych fiszek w tym zestawie",
			flashcardExist: "Dana fiszka istnieje już w wybranym zestawie",
			emptyName: "Uzupełnij nazwę a następnie spróbuj ponownie",
			errorBoundary: {
				header: "Coś nam tu poszło nie tak.",
				subheader:
					"Pracujemy aby naprawić błąd. Spróbuj ponownie później. Jeśli problem się powtarza skontaktuj się znami.",
				buttonText: "Wróc na stronę główną",
			},
			emptyItems:
				"Dla podanych parametrów nie znaleziono żadnych pytań. Zmień parametry zapytania i spróbuj ponownie.",
			emptyComment: "Komentarz nie może pozostać pusty",
			addCommentProblem:
				"Wystąpił problem podczas dodawania komentarza. Spróbuj później lub skontaktuj się z nami.",
			uploadImageProblem:
				"Wystąpił problem podczas ładowania pliku. Upewnij się że rozmiar oraz format pliku jest odpowiedni.",
			maxSourceLength: "Maksymalna długość znaków dla źródła to {{maxLength}}",
			emptyPromocode: "The code can not be empty.",
			messageToShort: "Minimalna długość wiadomości to {{minLength}} znaków",
			commentNotFound: "Niestety komentarz został usunięty",
			tooManyRequests: "Zbyt wiele zapytań, spróbuj ponownie później",
			tooManyLessons:
				"Za mało pytań na dzień aby wygenerować kurs. Zmień konfigurację i spróbuj ponownie",
			wrongPromocode: "Kod promocyjny nie istnieje",
		},
		success: {
			commentAdded: "Twój komentarz został dodany pomyślnie.",
			commentWaiting: "Twój komentarz oczekuje na akceptacje naszego zespołu.",
		},
		shortcuts: {
			prevQuestion: "Poprzednie pytanie",
			nextQuestion: "Następne pytanie",
			answerA: "Odpowiedź a",
			answerB: "Odpowiedź b",
			answerC: "Odpowiedź c",
			answerD: "Odpowiedź d",
			answerE: "Odpowiedź e",
			article: "Otwórz/zamknij artykuł",
			discussion: "Otwórz/zamknij artykuł",
			favorite: "Dodaj/usuń z ulubionych",
			comments: "Otwórz/zamknij komentarze",
		},
		tooltips: {
			showAllExams: "Zobacz wszystkie egzaminy",
			showAllCourses: "Zobacz wszystkie kursy",
			showAllDecks: "Zobacz wszystkie zestawy",
			createNewExam: "Utwórz nowy egzamin",
			createNewDeck: "Utwórz nowy zestaw",
			createNewCourse: "Utwórz nowy kurs",
			removeComment: "Usuń komentarz",
			removeQuestion: "Usuń pytanie",
			replyComment: "Odpowiedz na komentarz",
			likeComment: "Polub komentarz",
			dislikeComment: "Usuń polubienie",
			sortComments: "Sortowanie",
			filterComments: "Filtry",
			settings: "Ustawienia panelu",
			notifications: "Notyfikacje",
			profile: "Profil użytkownika",
			admin: "Moderator z naszego zespołu",
			watchQuestion: "Zobacz pytanie",
			basicExamType: "Egzamin standardowy",
			simulationWithoutTimer: "Symulacja egzaminu bez timera",
			simulationWithTimer: "Symulacja egzaminu z timerem",
			excludedAnswer: "Wyklucz odpowiedź",
		},
		defaultsText: {
			emptyName: "Brak nazwy",
			logout: "Wyloguj się",
			yoursScore: "Twój wynik",
			score: "Wynik",
			finished: "Zakończono",
			showAll: "Zobacz wszystkie",
			filter: "Filtry",
			found: "Znaleziono",
			minimize: "Zminimalizuj",
			expand: "Rozwiń filtry",
			actions: "Akcje",
			emptyRows: "Trochę tu pusto...",
			emptyCommentsList: "Nie znaleziono pytań ostatnio skomentowanych",
			emptyUsersQuestionList: "Brak pytań od użytkowników",
		},
		commands: {
			send: "Wyślij",
			create: "Utwórz",
			browse: "Przeglądaj",
			resolve: "Rozwiąż",
			remove: "Usuń",
			cancel: "Anuluj",
			skip: "Pomiń",
			save: "Zapisz",
			refresh: "Odśwież",
			edit: "Edytuj",
			back: "Wróć",
			close: "Zamknij",
			add: "Dodaj",
			reorder: "Zmień kolejność",
			prev: "Poprzednie",
			next: "Następne",
			mark: "Zaznacz",
			unmark: "Odznacz",
			start: "Rozpocznij",
			blocked: "Zablokowane",
			resume: "Wznów",
			watch: "Obejrzyj",
			search: "Szukaj",
			clear: "Wyczyść",
			added: "Dodano",
			more: "Więcej",
			loading: "Ładowanie...",
			saved: "Zapisano",
			use: "Użyj",
			all: "Wszystkie",
			addAttachment: "Dodaj załącznik",
			nextQuestion: "Następne pytanie",
			prevQuestion: "Poprzednie pytanie",
			addFlashcard: "Dodaj do zestawu",
			saveChanges: "Zapisz zmiany",
			seeMore: "Zobacz więcej",
			collapse: "Zwiń",
			expand: "Rozwiń",
			news: " Nowość!",
			confirm: "Potwierdź",
			import: "Importuj",
		},
		csvImport: {
			frontShort: "Przód",
			backShort: "Tył",
			optional: "opcjonalnie",
			skip: "(pomiń)",
			title: "Importuj CSV / XLSX",
			description:
				"Wybierz kolumny z pliku, które odpowiadają przodowi i tyłowi fiszki",
			front: "Przód fiszki",
			back: "Tył fiszki",
			count: "Liczba fiszek: {{count}}",
			hasHeader: "Pierwszy wiersz zawiera nagłówki",
			deckName: "Nazwa zestawu",
			deckDescription: "Opis zestawu",
		},
		flashcardsImport: {
			title: "Importuj fiszki",
			dropzone: {
				drop: "Przeciągnij plik tutaj lub",
				pick: "wybierz z dysku",
			},
			pickFile: "Wybierz plik",
			pickFileHint:
				"CSV i XLSX poprosimy o dopasowanie kolumn. Anki i TXT importujemy od razu.",
			fileSelected: "Plik wybrany",
			changeFile: "Zmień plik",
			unsupported: "Nieobsługiwany format pliku",
			tooFewColumns: "Plik musi mieć co najmniej 2 kolumny",
			error: "Nie udało się odczytać pliku",
			rows_one: "{{count}} wiersz",
			rows_few: "{{count}} wiersze",
			rows_many: "{{count}} wierszy",
			ankiReady_one:
				"Plik Anki ma gotowe strony fiszek – niczego nie trzeba dopasowywać. Wykryto {{count}} fiszkę.",
			ankiReady_few:
				"Plik Anki ma gotowe strony fiszek – niczego nie trzeba dopasowywać. Wykryto {{count}} fiszki.",
			ankiReady_many:
				"Plik Anki ma gotowe strony fiszek – niczego nie trzeba dopasowywać. Wykryto {{count}} fiszek.",
			mapColumns: "Dopasuj kolumny",
			mapColumnsHint: "Wskaż kolumny z przodem i tyłem fiszki.",
			preview: {
				title: "Sprawdź podgląd",
				hint: "Tak będą wyglądać zaimportowane fiszki.",
				more_one: "… i {{count}} kolejny wiersz",
				more_few: "… i {{count}} kolejne wiersze",
				more_many: "… i {{count}} kolejnych wierszy",
			},
			steps: {
				file: "Plik",
				columns: "Kolumny",
				preview: "Podgląd",
			},
			next: "Dalej",
			fileReady: "Plik gotowy. Przejdź dalej, żeby dopasować kolumny.",
			fileReadyAnki: "Plik gotowy. Przejdź dalej, żeby zobaczyć podgląd.",
			mapColumnsHintDecks:
				"Wskaż kolumny z przodem i tyłem fiszki. Nazwa i opis zestawu są opcjonalne.",
			column: "kol. {{letter}}",
			field: "pole {{n}}",
			importCount_one: "Importuj {{count}} fiszkę",
			importCount_few: "Importuj {{count}} fiszki",
			importCount_many: "Importuj {{count}} fiszek",
			anki: {
				noCards: "Nie znaleziono fiszek w pliku",
				parsing: "Wczytuję zestawy...",
				foundDecks: "Znalezione zestawy",
			},
			page: {
				title: "Importuj zestawy fiszek",
				faq: "FAQ",
				importedCount: "Zaimportowane zestawy",
				emptyTitle: "Nie masz dodanych żadnych zestawów",
				emptySubtitle:
					"Użyj przycisku poniżej i wgraj zestawy fiszek. Dodane pliki pojawią się w tym miejscu",
				createDecks: "Utwórz zestawy",
				defaultDeckName: "Nowy zestaw",
				success: "Zestawy zostały utworzone",
				error: "Nie udało się utworzyć zestawów",
				maxDecks_one: "Możesz utworzyć maksymalnie {{count}} zestaw na raz",
				maxDecks_few: "Możesz utworzyć maksymalnie {{count}} zestawy na raz",
				maxDecks_many: "Możesz utworzyć maksymalnie {{count}} zestawów na raz",
				partialError_one:
					"Utworzono {{count}} zestaw, pozostałych nie udało się utworzyć — spróbuj ponownie",
				partialError_few:
					"Utworzono {{count}} zestawy, pozostałych nie udało się utworzyć — spróbuj ponownie",
				partialError_many:
					"Utworzono {{count}} zestawów, pozostałych nie udało się utworzyć — spróbuj ponownie",
				deckTooLarge:
					"Zestaw „{{name}}” jest za duży — podziel go na mniejsze zestawy",
			},
		},
		globalSearch: {
			placeholder: "Szukaj pytań, artykułów, fiszek…",
			clear: "Wyczyść",
			loadMore: "Załaduj więcej ({{shown}} z {{total}})",
			empty:
				"Brak wyników dla „{{phrase}}”. Spróbuj krótszej frazy lub wyłącz filtry.",
			showOnly: "Pokaż tylko:",
			ownDeck: "Twój zestaw",
			companyDeck: "Oficjalny zestaw",
			tabs: {
				all: "Wszystko",
				questions: "Pytania",
				articles: "Artykuły",
				decks: "Fiszki",
			},
			filters: {
				starred: "Z gwiazdką",
				wrongAnswers: "Błędnie rozwiązane",
				isUnanswered: "Nierozwiązane",
			},
			sections: {
				questions: "Pytania",
				articles: "Artykuły",
				decks: "Zestawy fiszek",
			},
			showAll: {
				questions: "Wszystkie pytania",
				articles: "Wszystkie artykuły",
				decks: "Wszystkie zestawy",
			},
			snippetSource: {
				title: "w tytule",
				question: "w treści pytania",
				answer: "w odpowiedzi {{letter}}",
				content: "w treści",
				description: "w omówieniu",
				flashcardFront: "w fiszce · przód",
				flashcardBack: "w fiszce · tył",
			},
			keys: {
				navigate: "nawigacja",
				open: "otwórz",
				close: "zamknij",
			},
			questions: "Szukaj po treści pytania...",
			articles: "Szukaj po tytule artykułu...",
			decks: "Szukaj po nazwie zestawu...",
		},
		units: {
			questions: "pytań",
			lessons: "lekcji",
			day: "dzień",
			flashcards: "fiszek",
			decks: "zestawów",
		},
		datePicker: {
			selectDate: "Wybierz datę",
			selectRangeTitle: "Wybierz zakres dat (max {{maxDays}} dni)",
			selectRangeTitleNoMax: "Wybierz zakres dat",
			cancel: "Anuluj",
			confirm: "Zobacz",
			set: "Ustaw",
		},
		auth: {
			services: {
				selectService: "Wybierz egzamin i zaloguj się na swoje konto",
				signInToService: "Zaloguj się do {{serviceName}}",
				title:
					"Twoja przestrzeń do skutecznej nauki przed egzaminami LEK i PES.",
				titleLDEK: "Twoja przestrzeń do skutecznej nauki przed egzaminem LDEK.",
				description:
					"Ucz się wygodnie do {{services}} w platformie {{serviceName}}",
				back: "Powrót na stronę głowną",
				pes: {
					name: "PES",
					description: "Państwowy Egzamin Specjalizacyjny",
				},
				lek: {
					name: "LEK",
					description: "Lekarski Egzamin Końcowy",
				},
				info: {
					examsLdek: "Wszystkie  egzaminy LDEK z prawidłowymi odpowiedziami",
					exams: "Wszystkie  egzaminy LEK i PES z prawidłowymi odpowiedziami",
					articles: "Artykuły medyczne i infografiki",
					flashcards: "Fiszki ułatwiające zapamiętywanie treści",
				},
			},
			signIn: "Zaloguj się",
			signingIn: "Logowanie...",
			createAccount: "Stwórz konto",
			signUp: "Zarejestruj się",
			signUpQuestion: "Nie masz konta?",
			signInQuestion: "Masz już konto?",
			forgotPassword: "Zapomniałeś hasła?",
			form: {
				password: "Hasło",
				login: "Nazwa użytkownika",
				email: "Adres e-mail",
				passwordRepeat: "Powtórz hasło",
				oldPassword: "Stare hasło",
				newPassword: "Nowe hasło",
			},
			alerts: {
				accountCreated: "Pomyślnie utworzono konto <0>{{email}}</0> w serwisie",
				passwordChanged:
					"Pomyślnie zmieniono hasło do konta. Użyj nowych danych aby się zalogować.",
			},
			resetPassword: {
				emailSent: {
					title: "Sprawdź swój email",
					subtitle: "Wysłaliśmy link resetujący hasło na twojego emaila.",
					backToLogin: "Wróć do logowania",
				},
				form: {
					title: "Zapomniałeś hasła?",
					subtitle:
						"Nic nie szkodzi. Wprowadź swój adres email a my wyślemy Ci link resetujący hasło.",
					email: "Wprowadź swój email",
					sending: "Wysyłamy do Ciebie emaila...",
				},
				setPassword: {
					subtitle: "Ustaw nowe bezpieczne hasło do swojego konta.",
					submit: "Ustaw nowe hasło",
					title: "Ustaw nowe hasło",
				},
				linkUsed: {
					title: "Link został już użyty",
					subtitle:
						"Niestety ten link został użyty, spróbuj zresetować hasło ponownie.",
					submit: "Zresetuj ponownie",
				},
			},
		},
		navbar: {
			flashcards: "Fiszki",
			courses: "Kursy",
			exams: "Egzaminy",
			articles: "Baza wiedzy",
			home: "Strona startowa",
			homeMobile: "Start",
			folders: "Foldery",
			yourFolders: "Twoje foldery",
			addFolder: "Nowy folder",
			more: "Więcej",
			guide: "Poradnik",
		},
		guide: {
			navigation: {
				previous: "Poprzednia sekcja",
			},
			addBlock: "Dodaj blok",
			globalWarning:
				"Edytujesz poradnik wspólny dla wszystkich specjalizacji — zmiany zobaczą użytkownicy każdej specjalizacji PES.",
			form: {
				name: "Nazwa sekcji",
				nameMaxLength: "Maksymalnie 255 znaków",
				isGlobal: "Sekcja wspólna dla wszystkich specjalizacji",
			},
			empty: "Poradnik jest w przygotowaniu.",
			banner: {
				title: "Nie wiesz od czego zacząć naukę?",
				subtitle:
					"Sprawdź nasz poradnik i przygotuj się do egzaminu według sprawdzonego schematu",
				action: "Zobacz poradnik",
			},
		},
		contentPicker: {
			examType: {
				title: "Wybierz typ egzaminu",
				basic: {
					title: "Standardowy",
					subtitle:
						"Utwórz swój nowy egzamin na podstawie dowolnie dobranych parametrów jak np.: ilość sesji, działów, pytań oznaczonych gwiazdką oraz błędnie rozwiązanych pytań.",
					submit: "Utwórz standardowy egzamin",
				},
				simulation: {
					title: "Symulacja testu",
					subtitle:
						"Stwórz egzamin i zasymuluj warunki prawdziewgo testu. W tej konfiguracji możesz edytować odpowiedzi, mierzyć czas, a poprawność odpowiedzi poznasz dopiero po zakończeniu testu.",
					submit: "Utwórz symulację testu",
				},
			},
			courseType: {
				title: "Wybierz typ kursu",
				searchPlaceholder: "Szukaj kursu",
				emptyText: "Nie znaleziono kursu dla podanych parametrów",
				emptyTemplates:
					"Pracujemy nad przygotowaniem kursów. Zajrzyj wkrótce :)",
				basic: {
					title: "Standardowy",
					subtitle:
						"Utwórz swój nowy kurs na podstawie dowolnie dobranych parametrów jak np.: ilość sesji, działów, pytań oznaczonych gwiazdką oraz błędnie rozwiązanych pytań.",
					submit: "Utwórz standardowy kurs",
				},
				templates: {
					title: "Wybierz gotowy kurs z bazy",
					subtitle:
						"Skorzystaj z przygotowanych kursów przez nas zespół i przygotuj się do egzaminu.",
					submit: "Wybierz kurs",
				},
			},
			exam: {
				title: "Egzaminy",
				create: {
					title: "Utwórz nowy egzamin",
					subtitle:
						"Utwórz swój nowy egzamin na podstawie dowolnie dobranych parametrów jak np.: ilość sesji, działów, pytań oznaczonych gwiazdką oraz błędnie rozwiązanych pytań.",
				},
				list: {
					title: "Twoje egzaminy",
					subtitle:
						"Kontynuuj swoje niedokończone egzaminy lub przeglądaj zakończone. Wygeneruj egzaminy z pytań oznaczonych gwiazdką lub błędnie rozwiązanych odpowiedzi z dowolnej liczby zaznaczonych egzaminów.",
				},
			},
			flashcards: {
				title: "Fiszki",
				create: {
					title: "Utwórz nowy zestaw",
					subtitle:
						"Utwórz swój nowy zestaw fiszek od nowa lub w oparciu o publicznie dostępne zestawy. Twój zostaw może być prywatny lub publiczny.",
				},
				list: {
					title: "Twoje zestawy",
					subtitle:
						"Przeglądaj swoje zestawy oraz powtarzaj fiszki w oparciu o algorytm spaced repetition, który ułatwi Tobie ich zapamiętanie.",
				},
				createOwn: {
					title: "Stwórz własny zestaw",
					subtitle:
						"Utwórz swój nowy zestaw fiszek Twój zostaw może być prywatny lub publiczny.",
					submit: "Utwórz zestaw",
				},
				browseExisting: {
					title: "Wybierz z gotowych zestawów",
					subtitle:
						"Wybierz zestaw z szerokiej listy i ucz się materiałów z przygotowanych i sprawdzonych treści",
					submit: "Utwórz zestaw",
				},
				importMany: {
					title: "Importuj wiele zestawów",
					subtitle:
						"Stwórz wiele zestawów fiszek na raz, importując pliki csv, txt czy też anki",
				},
			},
			flashcardsMode: {
				spacedRepetition: {
					title: "Spaced repetiton",
				},
				knowDontKnow: {
					title: "Znam/nie znam",
				},
			},
			courses: {
				title: "Kursy",
				create: {
					title: "Utwórz nowy kurs",
					subtitle:
						"Utwórz swój nowy kurs na podstawie na podstawie dowolnie dobranych parametrów jak np.: ilość sesji, działów, kategorii tematycznych, ilość pytań/dzień oraz czasu trwania kursu.",
				},
				list: {
					title: "Twoje kursy",
					subtitle: "Przeglądaj swoje kursy i kontynuuj naukę.",
				},
			},
		},
		filters: {
			popper: {
				selectFilter: "Wybierz filtr",
			},
			viewType: {
				select: "Wybierz widok",
				list: "Lista",
				carusel: "Karuzela",
			},
			exams: {
				timer: {
					title: "Timer",
					examTime: "Czas trwania egzaminu:",
					timePerQuestion: "Czas na rozwiązanie pytania: ",
					timeHint: "Na egzaminie standardowy czas na pytanie wynosi 1 minutę",
				},
				typeOfExam: {
					title: "Typ bazy pytań",
					lek: {
						hint: "Wybierz bazę pytań, z której wygenerujesz egzamin. Pozostaw to pole puste, jeśli chcesz wygenerować egzamin zawierający pytania zarówno z bazy pytań CEM jak i historyczne pytania LEK.",
						cem: {
							title: "Baza pytań CEM",
							hint: "Pytania z bazy pytań CEM (70% na egzaminie podchodzi z bazy)",
						},
						all: {
							title: "Archiwalne pytania",
							hint: "Pytania z LEKu od 2008 roku nie będące częścią bazy pytań CEM",
						},
					},
					pes: {
						hint: "Wybierz bazę pytań, z której wygenerujesz egzamin. Pozostaw to pole puste jeśli chcesz wygenerować egzamin zawierający pytania zarówno z oficjalnych pytań CEM jak i odtworzonych pytań.",
						cem: {
							title: "Oficjalne pytania",
							hint: "Oficjalne pytania PES opublikowane przez CEM",
						},
						all: {
							title: "Odtworzone pytania",
							hint: "Pytania PES odtworzone przez Zespół EgzaminLEK",
						},
					},
				},
				departments: {
					title: "Wybierz działy",
					search: "Szukaj...",
					lekHint: "Możesz zawęzić tematykę egzaminu do konkretnych działów.",
					pesHint:
						"Możesz zawęzić tematykę egzaminu do konkretnych działów z {{specialisation}}.",
				},
				terms: {
					title: "Wybierz terminy sesji",
				},
				additional: {
					title: "Opcje dodatkowe",
					starred: "Pytania oznaczone gwiazdką",
					wrongAnswers: "Błędnie rozwiązane pytania",
					skipCanceledQuestions: "Pomiń anulowane pytania",
					questionWithNote: "Pytania z notatką",
					unanswered: "Wybierz tylko nierozwiązane pytania",
					countOfQuestions: "Ile pytań ma zawierać egzamin?",
					hint: "Pytania będą losowane z zaznaczonych przez Ciebie opcji",
					generateRandomExam: "Wygeneruj losowy test",
				},
				consultants: {
					title: "Konsultanci krajowi",
				},
				cemVersions: {
					title: "Wersja opublikowanej bazy CEM",
					hint: "Możesz zawęzić ilość pytań do danej wersji bazy CEM",
				},
				commentsNotifications: {
					title: "Ostatnio skomentowane",
					unread: "Nieodczytane",
					all: "Wszystkie (do 30 dni)",
				},
				aiDiscussions: {
					title: "Omówienia AI",
					isAiUnapproved: "Pytania bez akceptacji omówienia",
					hasUnresolvedReviews: "Pytania z nierozwiązanymi uwagami",
					refresh: "Odśwież listę pytań",
				},
				specialisations: {
					title: "Specjalizacje",
				},
				level: {
					title: "Poziom trudności pytań",
					filterHint:
						"Poziom trudności ustalony na podstawie odpowiedzi naszych użytkowników",
					hint: {
						title: "Odpowiedzi naszych użytkowników",
						correctAnswers: "Błędnych odpowiedzi",
						wrongAnswers: "Poprawnych odpowiedzi",
					},
					levels: {
						hard: "Trudne",
						medium: "Średnie",
						easy: "Łatwe",
					},
				},
			},
			courses: {
				date: {
					endDate: "Przewidywana data zakończenia kursu:",
				},
			},
			decks: {
				permission: {
					title: "Dostępność zestawu",
					public: "Publiczny",
					private: "Prywatny",
					publicDescription:
						"Wszyscy mogą zobaczyć zestaw i uczyć się z niego. Edytujesz tylko Ty.",
					privateDescription:
						"Tylko Ty widzisz zestaw i możesz się z niego uczyć.",
				},
				tags: {
					title: "Tagi",
				},
			},
		},
		creators: {
			selectFolders: "Dodaj do folderów",
			foldersSelected: "Foldery ({{count}})",
			foldersSelectedLabel: "Foldery:",
			exams: {
				title: "Utwórz nowy egzamin",
				inputPlaceholder: "Podaj nazwę egzaminu",
				counterText: "Ilość pytań",
				creating: "Tworzę egzamin...",
				examName: "Nazwa egzaminu",
				removeFilters: "Usuń filtry",
				helpCenter: "Sprawdz jak w pełni używać naszego kreatora egzaminów",
				hint: "FAQ",
				helpCenterUrlLek: "https://egzaminlek.pl/blog?tags=3",
				helpCenterUrlPes: "https://egzaminlek.pl/blog?tags=4",
			},
			courses: {
				title: "Utwórz nowy kurs",
				inputPlaceholder: "Podaj nazwę kursu",
				counterText: "Ilość pytań",
				creating: "Tworzę egzamin...",
				removeFilters: "Usuń filtry",
				countOfQuestionsPerDay: "Ile pytań dziennie chcesz rozwiązywać?",
				day: "dzień",
				tip: "Z naszego doświadczenia wynika, że na każde pytanie trzeba poświęcić około 2min",
			},
			decks: {
				decksNotFound: "Nie znaleziono zestawu",
				noDescription: "Brak opisu do zestawu",
				flashcardsInDeck: "Fiszki w tym zestawie",
				title: "Nowy zestaw",
				deckName: "Nazwa zestawu",
				inputPlaceholder: "Nazwij swój zestaw",
				counterText: "Ilość fiszek w zestawie",
				creating: "Tworzę zestaw",
				uploadingImages: "Wysyłam zdjęcia...",
				draftModal: {
					title: "Masz niezapisany zestaw",
					description_one:
						"Znaleźliśmy roboczą wersję Twojego zestawu (<b>{{count}} fiszka</b>). Chcesz ją przywrócić czy zacząć od nowa?",
					description_few:
						"Znaleźliśmy roboczą wersję Twojego zestawu (<b>{{count}} fiszki</b>). Chcesz ją przywrócić czy zacząć od nowa?",
					description_many:
						"Znaleźliśmy roboczą wersję Twojego zestawu (<b>{{count}} fiszek</b>). Chcesz ją przywrócić czy zacząć od nowa?",
					restore: "Przywróć",
					discard: "Zacznij od nowa",
				},
				addFlashcard: "Dodaj fiszkę",
				addToDeck: "Dodaj fiszkę do zestawu",
				addOwnFlashcard: "Dodaj własną fiszkę do zestawu",
				importDecks: "Importuj zestawy",
				createDeck: "Utwórz zestaw",
				descriptionToggle: "Opis zestawu (opcjonalne)",
				descriptionPlaceholder: "Opisz swój zestaw",
				errors: {
					emptyDeck: "Nie można utworzyć zestawu bez fiszek.",
					nameRequired: "Aby utworzyć zestaw, uzupełnij pole z nazwą",
					saveError: "Nie udało się zapisać zestawu",
				},
			},
		},
		foldersList: {
			search: "Szukaj folderu",
			title: "Foldery",
			newFolder: "Nowy folder",
			sort: {
				updatedAt: "Data aktualizacji",
				createdAt: "Data utworzenia",
				alphabetical: "Alfabetycznie",
				asc: "Rosnąco",
				desc: "Malejąco",
			},
		},
		folder: {
			movedToFolderSuccess: "Przeniesiono do folderu",
			copiedToFolderSuccess: "Skopiowano do folderu",
			removedFromFolderSuccess: "Usunięto z folderu",
			addToFolder: "Dodaj do folderu",
			editFolder: "Edytuj folder",
			selectMany: "Zaznacz wiele",
			deleteFolder: "Usuń folder",
			removeFromFolderTitle: "Usuń z folderu",
			showAll: "Pokaż wszystkie",
			loading: "Ładowanie...",
			loadMore: "Załaduj więcej",
			showing: "Wyświetlane:",
			showingCountValues: "{{loaded}} z {{total}} elementów",
			selectedElements: "Wybrane elementy",
			move: "Przenieś",
			copy: "Kopiuj",
			removeFromFolder: "Usuń",
			search: "Szukaj",
			selectedCount: "Wybrano: {{count}}",
			moveToFolder: "Przenieś do folderu",
			moveToFolderTitle: "Przenieś do folderu",
			copyToFolder: "Kopiuj do folderu",
			copyToFolderTitle: "Kopiuj do folderu",
			movingLabel: "Przenosisz:",
			copyingLabel: "Kopiujesz:",
			itemsCount_one: "{{count}} element",
			itemsCount_few: "{{count}} elementy",
			itemsCount_many: "{{count}} elementów",
			searchFolder: "Szukaj folderu",
			targetFolders: "Do folderu: <0>{{names}}</0>",
			selectedFolders: "Wybrane: <0>{{names}}</0>",
			chooseFolders: "Wybierz foldery z listy",
			selectContentToFolder: "Wybierz treści do folderu {{folderName}}",
			newExam: "Nowy egzamin",
			newCourse: "Nowy kurs",
			newDeck: "Nowy zestaw",
			newNote: "Nowa notatka",
			tabs: {
				all: "Wszystkie",
				flashcards: "Fiszki",
				exams: "Egzaminy",
				courses: "Kursy",
				notes: "Notatki",
			},
			searchResultsFor: 'Wyniki dla "{{query}}"',
			noSearchResults: "Brak wyników wyszukiwania",
			noCourses: "Nie masz jeszcze żadnych kursów",
			noExams: "Nie masz jeszcze żadnych egzaminów",
			noDecks: "Nie masz jeszcze żadnych zestawów fiszek",
			noNotes: "Nie masz jeszcze żadnych notatek",
			createCourse: "Utwórz kurs",
			createExam: "Utwórz egzamin",
			createDeck: "Utwórz zestaw fiszek",
			createNote: "Utwórz notatkę",
			addNext: "Dodaj kolejny",
			emptyList: {
				title: "Czegoś tu brakuje...",
				description:
					"Dodaj elementy do folderu, a wtedy pojawią się w tym miejscu",
				button: "Dodaj elementy",
			},
		},
		editor: {
			placeholder: "Zacznij pisać...",
			saveError: "Nie udało się zapisać",
			uploadError: "Nie udało się dodać zdjęcia",
			uploading: "Zapisywanie...",
			table: {
				title: "Tabela",
				insert: "Wstaw tabelę",
				addColumnAfter: "Dodaj kolumnę",
				deleteColumn: "Usuń kolumnę",
				addRowAfter: "Dodaj wiersz",
				deleteRow: "Usuń wiersz",
				toggleHeaderRow: "Nagłówek wiersza",
				deleteTable: "Usuń tabelę",
				addTitle: "Dodaj tytuł tabeli",
				removeTitle: "Usuń tytuł tabeli",
				addNote: "Dodaj legendę",
				removeNote: "Usuń legendę",
				titlePlaceholder: "Tytuł tabeli",
				notePlaceholder: "Legenda, np. * objaśnienie",
			},
		},
		note: {
			untitled: "Notatka bez tytułu",
			titleLabel: "Nazwa notatki",
			save: "Zapisz zmiany",
			cancel: "Anuluj",
			emptyContent: "Treść notatki nie może być pusta",
			saveError: "Nie udało się zapisać notatki",
			saveSuccess: "Notatka została zapisana",
		},
		validation: {
			required: "To pole jest wymagane",
			maxChars: "Maksymalnie 255 znaków",
		},
		menuActions: {
			emptyActions: "Brak możliwych akcji",
			folder: {
				folders: "Foldery",
				moveToFolder: "Przenieś do innego folderu",
				copyToFolder: "Kopiuj do folderu",
				removeFromFolder: "Usuń z folderu",
			},
			course: {
				resume: "Wznów kurs",
				generateExamFromWrongAnswers: "Wygeneruj egzamin z błędnych odpowiedzi",
				generateCourseFromWrongAnswers: "Wygeneruj kurs z błędnych odpowiedzi",
				remove: "Usuń kurs",
				edit: "Edytuj kurs",
				sections: "Rozdziały",
				copyCourse: "Rozwiąż kurs ponownie",
				moveToFolder: "Przenieś do folderu",
			},
			courseSection: {
				statistics: "Statystyki",
			},
			flashcards: {
				resolve: "Rozwiąż zestaw",
				resolveAgain: "Rozwiąż ponownie",
				show: "Obejrzyj zestaw",
				share: "Udostępnij zestaw",
				edit: "Edytuj zestaw",
				preview: "Podgląd zestawu",
				remove: "Usuń zestaw",
				useDeck: "Ucz się z tego zestawu",
				moveToFolder: "Przenieś do folderu",
				allFlashcards: "Wszystkie fiszki",
				addFlashcard: "Dodaj fiszkę",
				statistics: "Statystyki",
				copy: "Skopiuj zestaw",
				copying: "Kopiowanie zestawu…",
			},
			exams: {
				statistics: "Statystyki",
				resume: "Wznów egzamin",
				changeName: "Zmień nazwę",
				remove: "Usuń egzamin",
				watch: "Obejrzyj egzamin",
				generateExamFromWrongAnswers: "Wygeneruj egzamin z błędnych odpowiedzi",
				generateFromStarredQuestions: "Wygeneruj egzamin z pytań z gwiazdką",
				copyExam: "Rozwiąż ponownie",
				moveToFolder: "Przenieś do folderu",
			},
			lessons: {
				generateExamFromWrongAnswers: "Wygeneruj egzamin z błędnych odpowiedzi",
				editNote: "Edytuj notatkę",
				deleteNote: "Usuń notatkę",
				addNote: "Dodaj notatkę",
			},
			section: {
				resolveAgain: "Rozwiąż ponownie sekcję",
				reportImprovement: "Co możemy ulepszy w sekcji?",
				remainingLessons: "Pozostało <0>{{left}}</0> z <0>{{all}}</0>",
			},
		},
		defaultNames: {
			wrongAnswers: "Błędnie rozwiązane",
			starred: "Oznaczone gwiazdką",
			commands: {
				cemDatabase: "Baza pytań CEM",
				allQuestions: "Wszystkie pytania CEM",
				categories: "Działy",
				all: "wszystkie",
				tags: "Tagi",
				subtags: "Subtagi",
				terms: "Terminy",
				starred: "Oznaczone gwiazdką",
				wrongAnswers: "Błędnie rozwiązane",
			},
		},
		modals: {
			guide: {
				confirmDeleteSection:
					"Czy na pewno chcesz usunąć ten rozdział razem z całą jego treścią?",
			},
			createFolder: {
				title: "Utwórz nowy folder",
				name: "Nazwa folderu",
				submit: "Utwórz folder",
				maxLengthError: "Nazwa folderu nie może mieć więcej niż 255 znaków",
				colorLabel: "Kolor folderu",
			},
			editFolder: {
				title: "Edytuj folder",
			},
			selectFolders: {
				title: "Wybierz foldery",
				confirm: "Wybierz",
			},
			statistics: {
				title: "Statystyki",
				failTitle: "Tym razem się nie udało",
				successTitle: "Gratulacje!",
				timeOver: "Czas na rozwiązanie egzaminu dobiegł końca. ",
				successSubtitle:
					"Udało Ci się zdać egzamin. Poniżej znajdziesz statystyki tego podejścia.",
				failSubtitle:
					"Nie udało Ci się zdać egzaminu. Poniżej znajdziesz statystyki tego podejścia.",
				correctAnswers: "Poprawne odpowiedzi",
				wrongAnswers: "Błędne odpowiedzi",
				skippedAnswers: "Pominięte pytania",
				cancelledAnswers: "Anulowane pytania",
				goToCourse: "Przejdź do kursu",
				yourScore: "Twój wynik: ",
				scoreLabel: "Twój wynik",
				passed: "Zdany",
				failed: "Niezdany",
				goToHome: "Powrót na stronę główną",
				answers: "Odpowiedzi",
				examInfo: "Dane egzaminu",
				currentScore: "Aktualny wynik",
				categoriesTitle: "Wyniki wg kategorii",
				correctCount_one: "{{count}} poprawna",
				correctCount_few: "{{count}} poprawne",
				correctCount_many: "{{count}} poprawnych",
				wrongCount_one: "{{count}} błędna",
				wrongCount_few: "{{count}} błędne",
				wrongCount_many: "{{count}} błędnych",
				questionsCount: "Ilość pytań",
				sectionInfo: "Sekcji",
				tabs: {
					examInfo: "Dane egzaminu",
					sectionInfo: "Statystyki",
					stats: "Statystyki",
					sectionStats: "Statystyki dla działu",
				},
				tooltips: {
					blocked: "Statystyki zostaną odblokowane po ukończeniu egzaminu",
					stats: "Statystyki egzaminu",
				},
				empty: {
					title: "Nie znaleziono danych",
					description:
						"Nie udzielono odpowiedzi w tym terminie. Zmień wyniki wyszukiwania aby ujrzeć swoje statystyki",
				},
			},
			deckStatistics: {
				title: "Zestaw został rozwiązany",
				subtitle:
					"Wszystkie fiszki zostały już dzisiaj przerobione. Wróć jutro i kontynuuj naukę.",
				statsHeader: "Statystyki",
				flashcardsCount: "Liczba fiszek",
				cardsCount_one: "{{count}} fiszka",
				cardsCount_few: "{{count}} fiszki",
				cardsCount_many: "{{count}} fiszek",
				sortLabel: "Sortowanie:",
				showOtherDecks: "Zobacz inne",
				keepLearning: "Ucz się dalej",
				resolveAgain: "Rozwiąż ponownie",
				tabs: {
					stats: "Statystyki",
					flashcards: "Fiszki",
				},
				statsType: {
					knowDontKnow: "Znam / nie znam",
					spacedRepetition: "Spaced repetition",
				},
				flashcardsSort: {
					updatedAt: "Data aktualizacji",
					bestKnown: "Najlepiej znane",
					worstKnown: "Najgorzej znane",
					mostAnswered: "Najczęściej odpowiadane",
					leastAnswered: "Najrzadziej odpowiadane",
				},
			},
			settings: {
				title: "Ustawienia",
				fontSizeTitle: "Rozmiar tekstu",
				darkMode: "Tryb ciemny",
				shortcuts: "Skróty klawiszowe",
				survey: "Ankieta satysfakcji",
				swipeable: "Gesty",
			},
			copyForbidden: {
				title: "Kopiowanie treści jest zakazane",
				subtitle:
					"Ze względów na zachowanie naszej konkurencji, która bez zawahania kopiuje naszą cieżką prace, zmuszeni zostaliśmy do zablokowania możliwości kopiowania treści na naszej stronie. Przepraszamy i dziekujemy za zrozumienie.",
				confirm: "Ok",
				customCopyText:
					"Uszanuj naszą cieżką prace, i zaprzestań kopiowania naszej treści. Dziękujemy!",
			},
			appInformation: {
				yoursVersion: "Twoja wersja aplikacji",
				availableVersion: "Dostępna wersja aplikacji",
				noInformation: "Brak informacji o aplikacji",
			},
			confirm: {
				regenerateCourseSection: {
					title: "Czy na pewno chcesz rozwiązać ponownie sekcje?",
					subtitle:
						"Wszelkie dane z tej sekcji zostaną usunięte, i będziesz musiał/a rozwiązać lekcje ponownie.",
				},
				regenerateDiscussion: {
					title: "Czy na pewno chcesz przegenerować omówienie?",
					subtitle:
						"Obecne omówienie zostanie trwale usunięte, a w jego miejsce wygenerujemy nowe od zera. Tej akcji nie da się cofnąć.",
				},
				deleteLessonNote: {
					title: "Czy na pewno chcesz usunąć notatkę?",
					subtitle:
						"Tej akcji nie da się cofnąć, notatka zostanie trwale usunięta.",
				},
			},
			changeName: {
				changed: "Zmieniono",
				previous: "Poprzednio:",
				restore: "Przywróć",
				empty: "Nazwa nie może być pusta.",
				exam: {
					title: "Zmień nazwę egzaminu",
					label: "Nazwa egzaminu",
					placeholder: "Wpisz nazwę egzaminu",
				},
				course: {
					title: "Zmień nazwę kursu",
					label: "Nazwa kursu",
					placeholder: "Wpisz nazwę kursu",
				},
			},
			deleteItem: {
				toDelete: "Do usunięcia:",
				exam: {
					title: "Usunąć egzamin?",
					description:
						"Egzamin zostanie trwale usunięty razem z odpowiedziami i statystykami. Tej operacji nie można cofnąć.",
					confirm: "Usuń egzamin",
				},
				exams: {
					title: "Usunąć egzaminy?",
					description:
						"Wybrane egzaminy zostaną trwale usunięte razem z odpowiedziami i statystykami. Tej operacji nie można cofnąć.",
					confirm: "Usuń egzaminy",
					count_one: "{{count}} egzamin",
					count_few: "{{count}} egzaminy",
					count_many: "{{count}} egzaminów",
					count_other: "{{count}} egzaminu",
				},
				course: {
					title: "Usunąć kurs?",
					description:
						"Kurs zostanie trwale usunięty razem z postępem nauki. Tej operacji nie można cofnąć.",
					confirm: "Usuń kurs",
				},
				courses: {
					title: "Usunąć kursy?",
					description:
						"Wybrane kursy zostaną trwale usunięte razem z postępem nauki. Tej operacji nie można cofnąć.",
					confirm: "Usuń kursy",
					count_one: "{{count}} kurs",
					count_few: "{{count}} kursy",
					count_many: "{{count}} kursów",
					count_other: "{{count}} kursu",
				},
				deck: {
					title: "Usunąć zestaw?",
					description:
						"Zestaw zostanie trwale usunięty razem ze wszystkimi fiszkami. Tej operacji nie można cofnąć.",
					confirm: "Usuń zestaw",
				},
				decks: {
					title: "Usunąć zestawy?",
					description:
						"Wybrane zestawy zostaną trwale usunięte razem ze wszystkimi fiszkami. Tej operacji nie można cofnąć.",
					confirm: "Usuń zestawy",
					count_one: "{{count}} zestaw",
					count_few: "{{count}} zestawy",
					count_many: "{{count}} zestawów",
					count_other: "{{count}} zestawu",
				},
				guideSection: {
					title: "Usunąć rozdział?",
					confirm: "Usuń rozdział",
				},
				flashcard: {
					title: "Usunąć fiszkę?",
					description:
						"Fiszka zostanie trwale usunięta. Tej operacji nie można cofnąć.",
					lastWarning:
						"To jest ostatnia fiszka w zestawie — usunięcie jej spowoduje usunięcie całego zestawu.",
					confirm: "Usuń fiszkę",
				},
				comment: {
					title: "Usunąć komentarz?",
					description:
						"Komentarz zostanie trwale usunięty. Tej operacji nie można cofnąć.",
					confirm: "Usuń komentarz",
				},
				removeFromFolder: {
					title: "Usunąć z folderu?",
					description:
						"Wybrane elementy zostaną usunięte z folderu, ale nie zostaną trwale usunięte. Nadal będziesz mieć do nich dostęp.",
					confirm: "Usuń z folderu",
				},
				folder: {
					title: "Usunąć folder?",
					description:
						"Usunięty zostanie tylko folder — wszystkie egzaminy, kursy, zestawy fiszek i notatki, które się w nim znajdują, pozostaną na Twoim koncie.",
					confirm: "Usuń folder",
				},
				note: {
					title: "Usunąć notatkę?",
					description:
						"Notatka zostanie trwale usunięta. Tej operacji nie można cofnąć.",
					confirm: "Usuń notatkę",
				},
				account: {
					title: "Usunąć konto?",
					description:
						"Konto <0>{{email}}</0> zostanie trwale usunięte. Tej operacji nie można cofnąć.",
					lossesTitle: "Bezpowrotnie stracisz:",
					lossExams: "wszystkie zgromadzone dane",
					lossStats: "statystyki i historię nauki",
					lossPlan: "pozostały dostęp do serwisu — bez zwrotu",
					confirmCheckbox:
						"Rozumiem, że moje dane zostaną trwale usunięte i nie będzie można ich odzyskać.",
					confirm: "Usuń konto",
				},
			},
			editDeck: {
				title: "Edytuj zestaw",
				tabs: {
					general: "Ogólne",
					flashcards: "Fiszki",
				},
				nameLabel: "Nazwa zestawu",
				descriptionLabel: "Opis zestawu",
				permissionLabel: "Dostępność zestawu",
				descriptionPlaceholder:
					"Np. najważniejsze pojęcia z ortopedii dziecięcej do LEK",
				optional: "opcjonalnie",
				lastChange: "Ostatnia zmiana: {{date}}",
				searchPlaceholder: "Szukaj w pytaniach i odpowiedziach",
			},
			addFlashcard: {
				title: "Dodaj fiszkę",
				description:
					"Wypełnij obie strony. Możesz dodać kilka fiszek naraz i zapisać je jednym przyciskiem.",
				importFromFile: "Importuj z pliku",
				addAnother: "Dodaj kolejną fiszkę",
				toSave: "Do zapisania:",
				count_one: "{{count}} fiszka",
				count_few: "{{count}} fiszki",
				count_many: "{{count}} fiszek",
				count_other: "{{count}} fiszki",
			},
			activatePromocode: {
				primaryText: "Voucher prezentowy",
				label: "Voucher prezentowy",
				alert:
					"Użyty kod należy zastosować podczas zakupu na naszej stronie zakupowej.",
			},
			updateAppModal: {
				primaryText: "Przejdź do {{name}}",
				header: "Nowa wersja już jest!",
				subtitle: "Przejdź do {{name}} i zaktualizuj aplikację już teraz.",
			},
			liveUpdateReady: {
				title: "Nowa wersja aplikacji",
				description:
					"Pojawiła się nowa aktualizacja aplikacji. Uruchom aplikację ponownie, żeby z niej skorzystać.",
				later: "Zrobię to później",
				restart: "Zaktualizuj teraz",
			},
			edit: {
				deck: {
					header: "Edytuj zestaw",
					name: "Nazwa zestawu",
					description: "Opis",
				},
			},
			courses: {
				generateCourseFromWrongAnswers: {
					header: "Podaj dodatkowe informacje o kursie",
					counter: "Ilość pytań w kursie",
				},
			},
			networkError: {
				header: "Brak połączenia do sieci",
				subheader1:
					"Nasza aplikacja potrzebuje połączenia z siecią do prawidłowego działania",
				subheader2: "Sprawdź swoje połączenie z internetem i spróbuj ponownie",
			},
			paymentRequired: {
				header: "Nie masz aktywnego dostępu",
				subheader:
					"Wybierz plan dopasowany do siebie i zacznij naukę – albo wróć do niej bez utraty postępów.",
				primary: "Wybierz plan",
				voucher: "Mam voucher",
				profile: "Przejdź do profilu",
				voucherCode: "Kod vouchera",
				voucherPlaceholder: "Wpisz kod",
				activate: "Aktywuj",
			},
			limitedAccess: {
				header: "Niestety nie masz dostępu do tej funkcjonalności",
				subheader:
					"Ale to nic straconego! Przejdź na naszą stronę i wybierz odpowiedni plan dla siebie aby tu zajrzeć",
				primary: "Wybierz plan",
			},
			reportError: {
				success: "Dziękujemy za zgłoszenie",
				primary: "Zgłoś błąd",
				header: "Zgłoś błąd",
				subheader: "Co możemy poprawić w tej sekcji?",
				stipulation: "Treść zgłoszenia",
				sourceInfo: "Źródło informacji",
			},
			reportTechnicalIssues: {
				header: "Zgłoś błąd techniczny",
				subheader: "Opisz napotkany błąd w polu poniżej",
				stipulation: "Treść zgłoszenia",
				submit: "Zgłoś błąd",
				buttonText: "Zgłoś błąd techniczny",
				successHeader: "Dziękujemy!",
				successSubheader:
					"Twoja wiadomość została wysłana, nasz zespół już pracuje nad naprawą błędu.",
				successSubmit: "Powrót na stronę główną",
			},
			reportCourseReservations: {
				header: "Co możemy ulepszyć?",
				subheader:
					"Daj nam znać co możemy dodać, aby ta sekcja stała się bardziej atrakcyjna.",
				stipulation: "Czego Ci brakuje?",
				submit: "Wyślij",
				successHeader: "Dziękujemy!",
				successSubheader:
					"Twoja wiadomość została wysłana, a nasz zespół już bierze się do pracy :)",
				successSubmit: "Zamknij",
			},
			requiredUpgradeApp: {
				primary: "Przejdź do {{name}}",
				header: "Twoja aplikacja wymaga aktualizacji",
				subheader: "Przejdź do {{name}} i zaktualizuj aplikację już teraz.",
			},
			wrongExam: {
				title: "Wybrano inny egzamin",
				description:
					"Zalogowałeś się do <0>{{current}}</0>, ale Twoje konto ma aktywny dostęp do <1>{{target}}</1>. Prawdopodobnie przy logowaniu wybrano niewłaściwy egzamin.",
				youAreHere: "Jesteś tutaj",
				hasAccess: "Masz dostęp",
				noAccess: "Brak dostępu",
				stay: "Pozostań na {{service}}",
				switch: "Przejdź do {{service}}",
			},
			setSpecialisation: {
				header: "Podaj nam specjalizację która Cię interesuje.",
				subheader:
					"Dzięki temu bedziemy w stanie lepiej dopastować do Ciebie nasz serwis. Możesz zmienić preferowaną specializację w każdym momencie w zakładce Profil.",
				title: "Specjalizacja",
			},
			shareDeck: {
				copy: "Skopiuj link",
				copied: "Skopiowano",
				private:
					"Twój zestaw jest prywatny. W zakładce edytuj zmień uprawnienie na publiczne, aby udostępnić ten zestaw.",
				link: "Link do zestawu",
			},
			wrongService: {
				primary: "Przejdź do {{name}}u",
				header: "Ups...To chyba nie tu.",
				subheader1: "Wygląda na to, że wybrałeś/aś błędny serwis.",
				subheader2: "Twoje konto jest aktywne w serwisie {{name}}.",
				subheader3:
					"Przejdź do poprawnego serwisu i korzystaj w pełni z naszej platformy.",
			},
			finishExam: {
				title: "Wychodzisz z egzaminu",
				lessonTitle: "Wychodzisz z lekcji",
				reviewTitle: "Kończysz przeglądanie",
				examNamePlaceholder: "Wpisz nazwę egzaminu",
				examNameRequired: "Nazwa egzaminu nie może być pusta.",
				examName: "Nazwa egzaminu",
				unresolved:
					"Nie wszystkie pytania zostały rozwiązane – rozwiązano <0>{{resolved}} z {{total}}</0>.",
				finishedInfo:
					"Egzamin jest zakończony. Możesz zmienić jego nazwę i wrócić do odpowiedzi w każdej chwili.",
				recommended: "Zalecane",
				later: "Dokończ później",
				laterDescription:
					"Zapiszemy Twoje postępy. Wrócisz do egzaminu w dowolnym momencie.",
				finish: "Zakończ egzamin",
				finishLesson: "Zakończ lekcję",
				finishDescription:
					"Zobaczysz wynik. Na pozostałe pytania nie będzie można już odpowiedzieć.",
				saveAndExit: "Zapisz i wyjdź",
			},
			closeExamView: {
				description: "Egzamin został zakończony",
				primaryText: "Zakończ przeglądanie",
			},
			finishedExamView: {
				description:
					"Wszystkie pytania zostały rozwiązane. Test zostanie zapisany jako zakończony.",
				primaryText: "Zakończ",
				title: "Czy chcesz zakończyć przeglądanie?",
			},
			finishedCourseExamView: {
				primaryText: "Powrót do kursu",
				title: "Czy chcesz zakończyć przeglądanie lekcji?",
			},
			unfinishedExamView: {
				description:
					"Nie wszystkie zadania zostały rozwiązane. Możesz zakończyć test lub wznowić go później",
				primaryText: "Zakończ",
				secondaryText: "Dokończ później",
				title: "Czy chcesz zakończyć egzamin?",
			},
			unfinishedCourseExamView: {
				description:
					"Nie wszystkie zadania z lekcji zostały rozwiązane. Możesz zakończyć lekcję lub wznowić ją później",
				primaryText: "Zakończ lekcję",
				secondaryText: "Dokończ później",
				title: "Czy chcesz zakończyć lekcję?",
			},
		},
		exam: {
			timer: {
				finishedAt: "Do końca egzaminu pozostało:",
				startTimer: "Wystartuj timer, żeby aktywować egzamin",
			},
			moderator: "Moderator",
			discussion: "Omówienie",
			discussionSubText: "Autor + AI",
			discussionSubTextAi: "AI",
			discussionSubTextAuthor: "Autor",
			discussionAi: "Omówienie AI",
			discussionAuthor: "Omówienie autorskie",
			source: "Źródła",
			article: "Artykuły",
			star: "Ulubione",
			comments: {
				title: "Komentarze",
				addComment: "Dodaj komentarz lub zdjęcie...",
				replyComment: "Odpowiedz na komentarz",
				addImage: "Dodaj zdjęcie do komentarza",
				sort: {
					newest: "Od najnowszych",
					oldest: "Od najstarszych",
					mostPopular: "Popularność",
				},
				filter: {
					onlyEgzaminlek: "Tylko EgzaminLEK",
				},
			},
			more: "Więcej",
			reportError: {
				title: "Zgłoś błąd",
				success:
					"Dziękujemy za zgłoszenie. Zajmiemy się nim najszybciej jak tylko możemy!",
				modal: {
					title: "Zgłoś błąd",
					subtitle: "Co możemy poprawić w tym pytaniu?",
					outdatedQuestion: "Nieaktualne pytanie",
					wrongAnswer: "Niepoprawna odpowiedź",
					missingImages: "Brak grafiki do pytania",
					bugInQuestion: "Błąd w treści pytania",
					another: "Inne",
					withoutCorrectAnswer: "Brak poprawnej odpowiedzi",
					wrongCategory: "Błędna kategoria pytania",
					questionInconsistentWithCurrentKnowledge:
						"Pytanie niezgodne z aktualną wiedzą",
					inputs: {
						reasonOfNotification: "Powód zgłoszenia",
						correctAnswer: "Poprawna odpowiedź",
						sourceOfInformation: "Źródło informacji",
						stipulation: "Zastrzeżenie",
					},
				},
			},
			stats: "Statystyki",
			questionLevel: "Trudność pytania",
			notes: {
				title: "Notatki",
				success: " notatkę",
				folderTitle: "Notatki z folderu",
				myNotes: "Moje notatki",
				addNote: "Dodaj notatkę",
				placeholder: "Dodaj notatkę lub zdjęcie...",
				preview: "Podgląd",
			},
			images: {
				title: "Grafiki do pytania",
				discussion: {
					title: "Grafiki do omówienia",
				},
			},
			cemDatabase: "Baza pytań CEM",
			correctAnswerFromCem:
				"W tym pytaniu odpowiedź poprawna wg klucza CEM to: {{answer}}",
			correctAnswerNotExistText:
				"To pytanie nie posiada poprawnej odpowiedzi bądź też zostało unieważnione.",
			answerNotSetText: "Nie udzielono odpowiedzi na to pytanie",
		},
		userDecks: {
			title: "Fiszki",
			tabs: {
				decks: "Twoje zestawy",
			},
			search: {
				placeholder: "Szukaj zestawu",
			},
			empty: "Nie masz jeszcze żadnych zestawów",
			emptyDescription:
				"Dodaj swój pierwszy zestaw, a wtedy pojawią się w tym miejscu",
			emptyButton: "Dodaj zestaw",
		},
		decks: {
			categoryLabel: "Kategoria:",
			filter: {
				all: "Wszystkie",
				admin: "Admin",
				users: "Użytkownicy",
			},
			search: {
				flashcardsCount_one: "{{count}} pojęcie",
				flashcardsCount_few: "{{count}} pojęcia",
				flashcardsCount_many: "{{count}} pojęć",
				preview: "Podgląd",
				learnSelected: "Ucz się z tych zestawów",
				learnSuccess: "Zestawy dodane do Twojej biblioteki",
				maxSelected_one: "Możesz wybrać maksymalnie {{count}} zestaw",
				maxSelected_few: "Możesz wybrać maksymalnie {{count}} zestawy",
				maxSelected_many: "Możesz wybrać maksymalnie {{count}} zestawów",
				empty: "Nie znaleziono zestawów",
				showAll: "Pokaż wszystkie",
				usedCount_one: "Rozwiązano {{count}} raz",
				usedCount_few: "Rozwiązano {{count}} razy",
				usedCount_many: "Rozwiązano {{count}} razy",
			},
			sort: {
				popularity: "Popularność",
				createdAt: "Data utworzenia",
				alphabetical: "Alfabetycznie",
				flashcardsToResolveCount: "Liczba fiszek do rozwiązania",
				ascending: "Rosnąco",
				descending: "Malejąco",
				tooltip: "Sortuj",
			},
			preview: {
				study: "Ucz się z tego zestawu",
				addToList: "Dodaj do listy",
				removeFromList: "Usuń z listy",
				searchPlaceholder: "Szukaj fiszki",
				searchResults: "Wyniki dla wyszukiwania: <0>{{query}}</0>",
				noResults: "Brak wyników dla wyszukiwania: {{query}}",
			},
			flashcardsAdded: "Dodano do zestawu",
			useFlashcardsInAnotherDeck: "Użyj fiszki w innym zestawie",
			gradeButtons: {
				0: "Powtórz",
				1: "Słabo",
				2: "Dobrze",
				3: "Proste",
			},
			knowDontKnow: {
				know: "Znam",
				dontKnow: "Nie znam",
			},
			modeMenu: {
				trigger: "Tryb",
				header: "Wybierz tryb rozwiązywania zestawu",
				repeatSuffix: "(powtórka)",
				loading: "Ładowanie…",
				spacedRepetition: {
					title: "Spaced repetiton",
					description:
						"Odpowiadaj na pytania i oceniaj swoją wiedzę. Fiszki, które znasz, wracają rzadziej, a te trudniejsze, częściej.",
				},
				knowDontKnow: {
					title: "Znam/ nie znam",
					description:
						"Oceń, czy znasz odpowiedź. Fiszki oznaczone „Znam” wracają rzadziej, a te z „Nie znam”, częściej.",
				},
				search: {
					placeholder: "Szukaj specjalizacji…",
					empty: "Brak specjalizacji pasujących do „{{query}}”",
				},
				view: {
					title: "Przeglądanie",
					description: "Przeglądaj fiszki i ucz się w swoim tempie",
				},
			},
			view: {
				previous: "Poprzednia",
				next: "Następna",
			},
			shortcuts: {
				spaceKey: "Spacja",
				flip: "Obróć",
				swipeHint: "Przesuń, aby ocenić",
			},
			front: "Przód",
			showFront: "Pokaż przód",
			progress: "Fiszka <0>{{current}}</0> z {{total}}",
			intervalShort: {
				minute: "{{count}}m",
				hour: "{{count}}h",
				day: "{{count}}d",
				month: "{{count}}mc",
				year: "{{count}}r",
			},
			interval: {
				minute_one: "{{count}} min",
				minute_few: "{{count}} min",
				minute_many: "{{count}} min",
				hour_one: "{{count}} godz.",
				hour_few: "{{count}} godz.",
				hour_many: "{{count}} godz.",
				day_one: "{{count}} dzień",
				day_few: "{{count}} dni",
				day_many: "{{count}} dni",
				month_one: "{{count}} miesiąc",
				month_few: "{{count}} miesiące",
				month_many: "{{count}} miesięcy",
				year_one: "{{count}} rok",
				year_few: "{{count}} lata",
				year_many: "{{count}} lat",
			},
			editFlashcard: "Edytuj fiszkę",
			deleteFlashcard: "Usuń fiszkę",
			frontPlaceholder:
				"Pytanie lub pojęcie, np. „Objawy choroby Scheuermanna”",
			backPlaceholder:
				"Odpowiedź lub definicja. Źródło możesz dodać jako cytat.",
			back: "Tył",
			editor: {
				editing: "Edytujesz fiszkę",
				saveShortcut: "Ctrl + Enter zapisuje",
				save: "Zapisz fiszkę",
			},
			allFlashcardsResolved: {
				title: "Wszystkie fiszki z tego zestawu zostały dziś rozwiązane.",
				subtitle: "Przyjdź jutro i kontynuuj naukę!",
				showAnotherDecks: "Zobacz inne zestawy",
				continue: "Przeglądaj zestaw",
			},
			removeFlashcard: {
				confirm:
					"Czy jesteś pewien/pewna że chcesz usunąć tą fiszkę z zestawu?",
			},
		},
		table: {
			elementsOnPage: "Elementów na stronie",
			exam: {
				title: "Twoje egzaminy",
				selectedItems: "Wybrano",
				empty: {
					title: "Trochę tu pusto...",
					submitText:
						"Dodaj nowy egzamin korzystając z przycisku w prawym rogu lub z panelu po lewej stronie.",
				},
				finished: {
					headers: {
						name: "Nazwa",
						countOfQuestions: "Ilość pytań",
						correctAnswers: "Poprawnych odpowiedzi",
						wrongAnswers: "Błędnych odpowiedzi",
						result: "Wynik",
						date: "Data ostatniego rozwiązania",
						actions: "Akcje",
					},
				},
				unfinished: {
					headers: {
						name: "Nazwa",
						countOfQuestions: "Ilość pytań",
						progress: "Progres",
						date: "Data ostatniego rozwiązania",
						actions: "Akcje",
					},
				},
				actions: {
					title: "Utwórz egzamin z zaznaczonych",
					generateExamFromWrongAnswers: "Błędne odpowiedzi",
					generateExamFromStarred: "Ulubione pytania",
					removeExams: "Usuń zaznaczone",
					removeComment: "Usuń komentarz",
					replyComment: "Odpowiedz na komentarz",
				},
				tabs: {
					unfinishedExams: "Rozpoczęte",
					finishedExams: "Ukończone",
					unfinished: "Rozpoczęte",
					finished: "Ukończone",
				},
			},
			courses: {
				headers: {
					name: "Nazwa",
					progress: "Progress",
					date: "Data ostatniego rozwiązywania",
					countOfLessons: "Ilość pozostałych lekcji",
					actions: "Akcje",
				},
				actions: {
					removeCourses: "Usuń zaznaczone",
					title: "Akcje z zaznaczonych",
				},
				title: "Twoje kursy",
				tabs: {
					courses: "Twoje kursy",
				},
				empty: {
					title: "Trochę tu pusto...",
					submitText:
						"Dodaj nowy kurs korzystając z przycisku w prawym rogu lub z panelu po lewej stronie.",
				},
			},
			decks: {
				title: "Twoje zestawy",
				empty: {
					title: "Trochę tu pusto...",
					submitText:
						"Dodaj nowy zestaw korzystając z przycisku w prawym rogu lub z panelu po lewej stronie.",
				},
				headers: {
					name: "Nazwa",
					countToResolve: "Ilość pozostałych fiszek",
					count: "Ilość fiszek w zestawie",
					date: "Data ostatniego rozwiązywania",
					code: "Kod zestawu",
					actions: "Akcje",
				},
				actions: {
					title: "Akcje z zaznaczonych",
					remove: "Usuń zestawy",
				},
				tabs: {
					decks: "Twoje zestawy",
				},
			},
		},
		courses: {
			week: "Tydzień",
			finished: "Ukończono",
			noDescription: "Ten kurs nie zawiera opisu",
		},
		stats: {
			exam: {
				title: "Statystyki egzaminu",
				correctAnswers: "Poprawne odpowiedzi",
				wrongAnswers: "Błędne odpowiedzi",
				dateOfSave: "Ostatnio",
			},
		},
		profile: {
			accountActiveUntil: "Konto aktywne do",
			purchase: "Przedłuż",
			tabs: {
				password: "Hasło",
				profile: "Moje dane",
				myProfile: "Moje konto",
				blog: "Blog",
				promocode: "Voucher prezentowy",
				removeAccount: "Usuń konto",
				refresh: "Przeładuj konto",
				purchase: "Kup dostęp",
				information: "Informacje i uaktualnienia",
				logOut: "Wyloguj się",
			},
			changePassword: "Zmień hasło",
			university: "Uniwersytet",
			userData: "Twoje dane",
		},
		statsBox: {
			correctAnswers: "Poprawne odpowiedzi",
			wrongAnswers: "Błędne odpowiedzi",
			title: "Statystyki",
		},
		articles: {
			back: "Baza wiedzy",
			examName: "Pytanie z artykułu",
			generate: "Rozwiąż pytania z artykułu",
			generating: "Generuje egzmain...",
			actions: "Akcje",
			showAll: "Otwórz wszystkie zakładki",
			contents: "Spis treści",
			images: "Obrazy do sekcji",
			sections: "Sekcje",
			tags: "Tagi",
		},
		relations: {
			relatedArticles: "Powiązane artykuły",
			recomendedArticles: "Rekomendowane artykuły",
		},
		search: {
			articles: {
				read: "Czytaj",
			},
			filters: {
				title: "Filtry",
				active_one: "{{count}} aktywny filtr",
				active_few: "{{count}} aktywne filtry",
				active_many: "{{count}} aktywnych filtrów",
				noneActive: "Brak aktywnych filtrów",
				pin: "Przypnij filtry",
				unpin: "Odepnij filtry",
				selected_one: "{{count}} wybrany",
				selected_few: "{{count}} wybrane",
				selected_many: "{{count}} wybranych",
				remove: "Usuń filtr {{name}}",
				clear: "Wyczyść",
				close: "Zamknij",
				showResults: "Pokaż wyniki",
				showResultsCount_one: "Pokaż {{count}} wynik",
				showResultsCount_few: "Pokaż {{count}} wyniki",
				showResultsCount_many: "Pokaż {{count}} wyników",
				chips: {
					departments: "Działy",
					typeOfExam: "Baza pytań",
					cemVersions: "Wersja bazy CEM",
					terms: "Terminy sesji",
					consultants: "Konsultanci",
					level: "Poziom trudności",
					additionalOption: "Opcje",
					searchValue: "Fraza",
					question: "Pytanie",
					author: "Autor",
				},
			},
			emptyState: "Nie znaleziono wyników dla podanych filtrów",
			empty: {
				questions: {
					title: "Brak pytań",
					titlePhrase: "Brak pytań dla „{{phrase}}”",
					description:
						"Spróbuj krótszej frazy lub innej odmiany słowa, albo usuń część filtrów.",
				},
				articles: {
					title: "Brak artykułów",
					titlePhrase: "Brak artykułów dla „{{phrase}}”",
					description:
						"Nie mamy jeszcze artykułu na ten temat. Sprawdź wyniki w innych zakładkach albo przejrzyj Bazę wiedzy według działów.",
				},
				decks: {
					title: "Brak fiszek",
					titlePhrase: "Brak fiszek dla „{{phrase}}”",
					description:
						"Żadna fiszka nie pasuje do tej frazy. Stwórz własny zestaw albo poszukaj tematu w pytaniach i artykułach.",
				},
				clearFilters: "Wyczyść filtry",
			},
			decks: {
				noDescription: "Brak opisu zestawu",
			},
		},
		infiniteScroll: {
			loading: "Ładowanie...",
			endOfList: "Nie masz więcej powiadomień",
		},
		course: {
			lessons: {
				revision: "Powtórka",
				challenge: "Wyzwanie",
				blockedRevisionHint: "Rozwiąż poprzednie 5 dni, aby odblokować powtórkę",
				blockedChallengeHint: "Rozwiąż całą sekcję, aby odblokować wyzwanie",
			},
		},
		notifications: {
			createdAt: "Data utworzenia: {{date}}",
			expired: "Wygasa: {{date}}",
			emptyState: "Nie masz żadnych powiadomień",
			title: "Powiadomienia",
			comment: {
				title:
					"Użytkownik <0>{{username}}</0> skomentował pytanie które obserwujesz",
				days: {
					plural: "{{days}} dni temu",
					singular: "{{days}} dzień temu",
					lastDay: "Dzisiaj",
					expired: "",
				},
			},
			commentAnswer: {
				title: "Użytkownik <0>{{username}}</0> odpowiedział na twój komentarz.",
			},
			commentLike: {
				title: "Użytkownik <0>{{username}}</0> polubił twój komentarz.",
			},
			forumQuestionAnswer: {
				title:
					"Użytkownik <0>{{username}}</0> dodał odpowiedź na pytanie które obserwujesz.",
			},
			questionChanged: {
				title: "Pytanie, które obserwujesz zostało zaaktualizowane.",
				subtitle: "{{message}}",
			},
			link: {
				expired: {
					days: {
						plural: "Wygasa za {{days}} dni",
						singular: "Wygasa za {{days}} dzień",
						lastDay: "Wygasa za mniej niż dzień",
						expired: "Wygasło...",
					},
				},
			},
			reportedErrorResponse: {
				title:
					"Użytkownik <0>{{username}}</0> rozpatrzył twoje zastrzeżenie do pytania.",
			},
			resolveNotification: "Ustaw jako przeczytane",
			editQuestionsButton: "Edytuj pytanie",
			actions: {
				setAsRead: "Oznacz jako przeczytane",
				stopSubscribe: "Przestań obserwować",
				remove: "Usuń notyfikacje",
				removeAll: "Usuń wszystkie notyfikacje",
				setAllAsRead: "Oznacz wszystkie jako przeczytane",
			},
		},
		uploader: {
			or: "lub",
			dropFile: "Upuść tu swój załącznik",
			takePhoto: "Zrób zdjęcie",
			chooseFile: "Wybierz plik",
			imageFormatsInfo:
				"Formaty: jpg, png, svg. Rozmiar max: <0>{{maxMB}} MB</0> ",
			importFiles: "Importuj pliki",
			formats: "Formaty",
			fileTooLarge: "Plik jest za duży",
			maxSizeHint: "Maksymalny rozmiar: {{maxMB}} MB.",
			fileReady: "Plik gotowy. Miniatura pokazuje, jak obraz będzie wyglądał.",
		},
		sources: {
			addNew: "Dodaj źródło:",
			placeholderSelect: "Znajdź źródło",
			placeholderInput: "Dodaj źródło (Tytuł książki, autor)",
			hintSelect: "Dodaj nowe źródło",
			hintInput: "Znajdź źródło",
			customSourceInfo:
				"Nowe źródło wymaga ręcznej weryfikacji naszego zespołu. Twój komentarz pojawi się w serwisie zaraz po zaakceptowaniu podanego przez Ciebie źródła.",
			useExistingSources: "Skorzystaj z <0>istniejących źródeł.</0>",
			addNewSource: "Nie widzisz źródła? <0>Dodaj nowe.</0>",
		},
		ai: {
			discussion: {
				missing: "Brak omówienia AI dla tego pytania.",
				generate: "Wygeneruj omówienie AI",
			},
			questionDetails: {
				userDetailsMessage: "Pomóż mi zrozumieć to pytanie.",
			},
			chatbot: {
				rateQuestion: "Jak oceniasz odpowiedź?",
				userRatings: "Oceny userów",
				responseGood: "Omówienie poprawne",
				responseBad: "Omówienie błędne",
				reviewPlaceholder:
					"Co możemy poprawić lub czego brakuje w tym omówieniu",
				reviewSent: "Dziękujemy za uwagę",
				loader: "Generuje odpowiedź",
				header: "Tutor AI",
				overviewHeader: "Omówienie AI",
				aiInfo:
					"Funkcja AI tutor jest obsługiwana przez sztuczną inteligencję, więc błędy są możliwe. Sprawdzaj dokładnie informacje.",
			},
			regenerate: {
				button: "Przegeneruj omówienie",
			},
			approval: {
				approve: "Zaakceptuj omówienie",
				revoke: "Cofnij akceptację",
				approvedBy: "Zaakceptowane przez {{user}} dnia {{date}}",
				approvedByInline: "Zweryfikował <0>{{user}}</0> dnia <1>{{date}}</1>",
				verifiedByModerator: "Omówienie zweryfikowane przez moderatora",
			},
			edit: {
				button: "Edytuj",
				cancelEdit: "Anuluj edycję",
				save: "Zapisz",
				saving: "Zapisywanie...",
				cancel: "Anuluj",
				saveSuccess: "Zmiany zostały zapisane",
				saveError: "Nie udało się zapisać zmian",
			},
			reviews: {
				title: "Uwagi od użytkowników",
				empty: "Brak uwag",
				loading: "Ładowanie...",
				loadMore: "Załaduj więcej",
				showing: "{{loaded}} z {{total}}",
				filter: {
					all: "Wszystkie",
					waiting: "Oczekujące",
					resolved: "Rozwiązane",
				},
				sort: {
					newest: "Najnowsze",
					oldest: "Najstarsze",
					updated: "Ostatnio zmienione",
					resolved: "Ostatnio rozwiązane",
				},
				status: {
					waiting: "Oczekuje",
					resolved: "Rozwiązane",
				},
				markAsResolved: "Oznacz jako rozwiązane",
				markedResolved: "Oznaczono jako rozwiązane",
				revertResolve: "Cofnij akceptację",
				revertedToWaiting: "Cofnięto akceptację",
				resolvedBy: "Rozwiązane przez {{user}} ({{date}})",
			},
			context: {
				title: "Kontekst (źródła RAG)",
				loading: "Ładowanie...",
				empty: "Brak kontekstu",
				count: "Fragmentów: {{count}}",
				filter: {
					all: "Wszystkie",
					cited: "Tylko cytowane",
				},
			},
		},
		globalChatbot: {
			open: "Otwórz Tutor AI",
			title: "Tutor AI",
			new: "Nowa",
			newConversation: "Nowa konwersacja",
			loadingConversation: "Ładowanie rozmowy...",
			collapse: "Zwiń do panelu",
			expand: "Rozszerz na całą szerokość",
			emptyState: "Rozpocznij konwersację wpisując pytanie w pole poniżej",
			composerPlaceholder: "Napisz swoje pytanie…",
			attachQuestion: "Dołącz pytanie",
			attachedQuestion: {
				label: "Pytanie ze strony",
			},
			thinking: "Analizuję pytanie...",
			details: {
				title: "Detale rozmowy",
				promptsCount_one: "{{count}} zapytanie",
				promptsCount_few: "{{count}} zapytania",
				promptsCount_many: "{{count}} zapytań",
				questionsCount_one: "{{count}} pytanie",
				questionsCount_few: "{{count}} pytania",
				questionsCount_many: "{{count}} pytań",
				contextQuestions: "Pytania użyte jako kontekst",
			},
			history: {
				title: "Historia pytań",
				today: "Dzisiaj",
				yesterday: "Wczoraj",
				searchPlaceholder: "Szukaj…",
				delete: "Usuń konwersację",
				popoverTitle: "Historia konwersacji",
				seeAll: "Zobacz wszystkie",
				empty: "Brak rozmów",
				noResults: 'Brak wyników dla "{{query}}"',
			},
			instructions: {
				title: "Jak używać",
			},
			limits: {
				period: {
					daily: "pytań dziś",
					weekly: "pytań w tym tygodniu",
					monthly: "pytań w tym miesiącu",
					last30Days: "pytań w ostatnich 30 dniach",
				},
				cadence: {
					daily: "codziennie",
					weekly: "co tydzień",
					monthly: "co miesiąc",
					last30Days: "co 30 dni",
				},
				tooltip: "Limit odnawia się {{cadence}} o {{time}}",
			},
		},
		commentedQuestions: {
			title: "Aktualności",
			userComment: "skomentował/a pytanie z sesji",
		},
		tawk: {
			chatTitle: "Czat",
		},
		news: {
			tabs: {
				lastCommented: "Ostatnio skomentowane",
				community: "Czat",
			},
			buttons: {
				addQuestion: "Zadaj pytanie",
			},
			searchPlaceholder: "Szukaj po treści pytania",
			forum: {
				userComment: "zadał/a pytanie",
				addAnswer: "Udziel odpowiedzi na pytanie",
				seeAnswers: "Zobacz odpowiedzi",
			},
		},
		aiPlayground: {
			params: {
				historyLength: "Długość historii czatu (0–10)",
				questionId: "ID pytania (kontekst)",
			},
		},
		aiUserChat: {
			thinking: "Myślę nad odpowiedzią...",
			startConversation:
				"Rozpocznij konwersację wpisując pytanie w pole poniżej",
			remaining: "Pozostało",
			of: "z",
			questions: "pytań",
		},
		userAccount: {
			successBox: {
				defaultMessage: "Zmiany zostały zapisane pomyślnie",
			},
			contextContainer: {
				saveButton: "Zapisz zmiany",
				cancelButton: "Anuluj",
			},
			passwordSection: {
				sectionTitle: "Hasło",
				editButton: "Edytuj",
				changePasswordTitle: "Zmień hasło",
			},
			subscriptionSection: {
				sectionTitle: "Subskrypcja",
				subscriptionWarning: "Twoja subskrypcja niedługo się kończy",
				specialisationLabel: "Specjalizacja",
				accessTypeTitle: "Typ dostępu",
				accessTypeLek: "egzamin LEK",
				accessTypeLdek: "egzamin LDEK",
				expiryDateLabel: "Data ważności",
				extendButton: "Przedłuż",
				activateButton: "Aktywuj",
				noSubscription: "Brak aktywnej subskrypcji",
			},
			accountSection: {
				editButton: "Edytuj",
				usernameLabel: "Nazwa użytkownika",
				emailLabel: "Email",
				loginLabel: "Login",
			},
			profile: {
				mainTitle: "Moje konto",
			},
			folder: {
				search: "Szukaj w folderze",
				tabs: {
					all: "Wszystkie",
					flashcards: "Fiszki",
					exams: "Egzaminy",
					courses: "Kursy",
					notes: "Notatki",
				},
				showAll: "Pokaż wszystkie",
				loadMore: "Załaduj więcej",
				loading: "Ładowanie...",
				showingCount: "Wyświetlane:\n{{loaded}} z {{total}} elementów",
				selectMany: "Zaznacz wiele",
				selectedElements: "Wybrane elementy",
				move: "Przenieś",
				copy: "Kopiuj",
				moveToFolder: "Przenieś do folderu",
				moveToFolderTitle: "Przenieś do folderu",
				removeFromFolder: "Usuń",
				removeFromFolderTitle: "Usuń z folderu",
				removeFromFolderDescription:
					"Wybrane elementy zostaną usunięte z folderu, ale nie zostaną trwale usunięte. Nadal będziesz mieć do nich dostęp.",
				selectedCount: "Wybrano: {{count}}",
				noOtherFolders: "Brak innych folderów",
				movedToFolderSuccess: "Przeniesiono do folderu",
			},
			chatWidget: {
				loading: "Ładowanie czatu...",
				openChat: "Kliknij, aby otworzyć czat",
				greeting: "Cześć",
				startInstruction:
					"Naciśnij dymek poniżej aby rozpocząć czat z naszym asystentem.",
				closeInstruction: "Po zakończeniu zamknij tę stronę :)",
				helpQuestion: "W czym możemy pomóc?",
				startChat: "Rozpocznij czat",
				startChatSubtitle: "Pomoc od naszego asystenta",
				start: "Rozpocznij",
				checkFaq: "Sprawdź nasz FAQ",
				checkFaqSubtitle: "Odpowiedzi na popularne pytania",
				openFaq: "Otwórz",
			},
		},
		sort: {
			descending: "Malejąco",
			ascending: "Rosnąco",
			tooltip: "Sortuj",
		},
		admin: {
			questions: {
				title: "Pytania",
				search: "Szukaj po treści pytania, odpowiedzi lub ID pytania…",
				empty: "Brak pytań dla tych filtrów",
				edit: "Edytuj",
				backToList: "Lista pytań",
				cemId: "ID CEM",
				expandComments: "Rozwiń komentarze",
				expandDiscussions: "Rozwiń omówienia",
				canceled: "Pytanie anulowane – brak poprawnej odpowiedzi",
				discussion: {
					own: "Autorskie",
					rag: "RAG",
					ragAccepted: "RAG ✓",
					ai: "AI",
				},
				values: {
					yes: "Tak",
					no: "Nie",
					accepted: "Zaakceptowane",
					notAccepted: "Niezaakceptowane",
					canceled: "Anulowane",
				},
				view: {
					title: "Widok",
					subtitle: "Przeciągnij, żeby zmienić kolejność kolumn",
					visible: "Widoczne",
					hidden: "Ukryte",
				},
				columns: {
					id: "ID",
					content: "Treść pytania",
					status: "Status omówienia",
					type: "Typ omówienia",
					ai: "Omówienie AI",
					rag: "Omówienie RAG",
					articles: "Artykuły",
					correctAnswer: "Poprawna",
					correctPercent: "% poprawnych",
					level: "Trudność",
					canceled: "Anulowane",
					images: "Obrazki",
					inBase: "W bazie pytań",
					cemNumber: "Nr w teście CEM",
					department: "Dział",
					session: "Sesja",
					discussion: "Status / typ omówienia",
					comments: "Komentarze",
				},
				status: {
					none: "Brak",
					accepted: "Zaakceptowane",
					unaccepted: "Niezaakceptowane",
				},
				type: {
					own: "Własne",
					rag: "RAG",
					none: "Brak",
				},
			},
			question: {
				edit: "Edytuj pytanie",
				id: "Id pytania: {{id}}",
				editMode: "Tryb edycji · admin",
				content: "Treść pytania",
				answers: "Odpowiedzi",
				answersHint: "Zaznacz kółko, żeby zmienić poprawną odpowiedź",
				markCorrect: "Poprawna: {{letter}}",
				correct: "Poprawna",
				noCorrect: "Brak poprawnej odpowiedzi",
				noCorrectHint: "Pytanie anulowane – nie liczy się do wyniku",
				save: "Zapisz zmiany",
				saveSuccess: "Pytanie zostało zapisane",
			},
			images: {
				title: "Obrazki z CDN",
				browse: "Szukaj",
				search: "Szukaj po nazwie pliku...",
				count_one: "<0>{{count}}</0> plik · ostatnio dodane na górze",
				count_few: "<0>{{count}}</0> pliki · ostatnio dodane na górze",
				count_many: "<0>{{count}}</0> plików · ostatnio dodane na górze",
				hint: "Kliknij „Kopiuj URL”, żeby wkleić adres obrazka do pytania",
				empty: "Brak plików",
				preview: "Podgląd",
				copy: "Kopiuj URL",
			},
			upload: {
				viewOnly:
					"Masz tylko podgląd obrazków — przeglądasz je przyciskiem „Szukaj”.",
				title: "Dodaj obrazek",
				graphic: "Obrazek",
				infographic: "Infografika",
				submit: "Zapisz",
				copy: "Skopiuj link",
				copied: "Link skopiowany",
				error: "Nie udało się wrzucić pliku",
				chooseFile: "Wybierz plik",
				graphicHint:
					"Obrazek do wstawienia w treść. Maksymalny rozmiar: {{maxMB}} MB.",
				infographicHint:
					"Infografika zostanie dodana do pytania. Maksymalny rozmiar: {{maxMB}} MB.",
				wrongFormat: "Nieobsługiwany format pliku",
				tooBig: "Plik jest za duży (maks. {{maxMB}} MB)",
				dropzone: "Przeciągnij plik tutaj lub <0>wybierz z dysku</0>",
				footer: "Formaty: {{formats}} · maks. <0>{{maxMB}} MB</0>",
			},
			decks: {
				add: "Dodaj zestawy",
			},
			blog: {
				posts: {
					title: "Wpisy",
					search: "Szukaj po tytule…",
					empty: "Brak wpisów",
				},
				post: {
					newTitle: "Nowy wpis",
					create: "Dodaj wpis",
					createSuccess: "Wpis został dodany",
					save: "Zapisz wpis",
					saveSuccess: "Wpis został zapisany",
					published: "Opublikowany",
					draft: "Szkic",
					tags: "Tagi",
					saveAndPublish: "Zapisz i opublikuj",
					saveAsDraft: "Zapisz jako szkic",
					chooseTags: "Wybierz tagi",
					pickTags: "Tagi wpisu",
					applyTags: "Zatwierdź",
				},
				tags: {
					title: "Tagi",
					add: "Dodaj tag",
					newTitle: "Nowy tag",
					editTitle: "Edytuj tag",
					edit: "Edytuj",
					save: "Zapisz tag",
					name: "Nazwa",
					slug: "Slug (opcjonalnie)",
					slugPlaceholder: "Puste = utworzony z nazwy",
					actions: "Akcje",
					delete: "Usuń",
					deleteTitle: "Usunąć tag #{{name}}?",
					deleteDescription:
						"Tag zostanie odpięty od wszystkich wpisów ({{count}}). Tej operacji nie da się cofnąć.",
					choosePosts: "Wybierz wpisy",
					attachTitle: "Przypisz wpisy",
					attachSave: "Zapisz",
					empty: "Brak tagów",
					search: "Szukaj tagu…",
					noPosts: "Brak wpisów z tym tagiem",
					detach: "Odepnij z tagu",
					emptyDescription:
						"Dodaj pierwszy tag, żeby przypisywać do niego wpisy.",
					postsCount_one: "{{count}} wpis",
					postsCount_few: "{{count}} wpisy",
					postsCount_many: "{{count}} wpisów",
				},
			},
			articleCategories: {
				listTitle: "Kategorie",
				search: "Szukaj kategorii…",
				untagged: "bez tagu",
				tagArticles: "Artykuły z tagiem {{name}}",
				untaggedArticles: "Artykuły bez tagu",
				noArticles: "Brak artykułów",
				emptyTitle: "Brak kategorii",
				emptyDescription:
					"Dodaj pierwszą kategorię, żeby przypisywać do niej artykuły.",
				tagsCount_one: "{{count}} tag",
				tagsCount_few: "{{count}} tagi",
				tagsCount_many: "{{count}} tagów",
				add: "Dodaj kategorię",
				newTitle: "Nowa kategoria",
				newTagTitle: "Nowy tag w {{name}}",
				addTag: "Dodaj tag",
				name: "Nazwa",
				empty: "Brak kategorii",
				attachTitle: "Przypisz artykuły",
				attachTo: "Przypisz artykuły: {{name}}",
				chooseArticles: "Wybierz artykuły",
				attachSave: "Zapisz",
				articlesCount_one: "{{count}} artykuł",
				articlesCount_few: "{{count}} artykuły",
				articlesCount_many: "{{count}} artykułów",
			},
			linked: {
				remove: "Odepnij",
			},
			checkDrawer: {
				selected: "Zaznaczono: {{count}}",
				search: "Szukaj…",
				empty: "Brak wyników",
			},
			article: {
				previewDark: "Podgląd w ciemnym motywie",
				previewLight: "Podgląd w jasnym motywie",
				untitled: "Bez tytułu",
				saveOptions: "Opcje zapisu",
				preview: "Podgląd",
				backToEdit: "Wróć do edycji",
				add: "Dodaj artykuł",
				newTitle: "Nowy artykuł",
				create: "Dodaj artykuł",
				createSuccess: "Artykuł został dodany",
				back: "Baza wiedzy",
				toc: "Spis treści",
				edit: "Edytuj artykuł",
				title: "Tytuł",
				content: "Treść",
				save: "Zapisz artykuł",
				cancel: "Anuluj",
				saveSuccess: "Artykuł został zapisany",
				cancelConfirm: "Wprowadzone zmiany w artykule zostaną utracone.",
			},
			ai: {
				error: "Nie udało się wygenerować treści AI.",
			},
			comments: {
				title: "Komentarze",
				search: "Szukaj w treści komentarza…",
				tabs: {
					questions: "Pod pytaniami",
					forum: "Czat",
				},
				answered: "odpowiedziane",
				notAnswered: "bez odpowiedzi",
				empty: "Brak komentarzy",
				resolved: "rozwiązane",
				status: {
					title: "Status",
					all: "Wszystkie",
					todo: "Bez odpowiedzi",
					resolved: "Rozwiązane",
				},
				resolve: {
					mark: "Oznacz jako rozwiązane",
					undo: "Cofnij",
					notFound: "Ten komentarz już nie istnieje",
				},
				replies_one: "{{count}} odpowiedź",
				replies_few: "{{count}} odpowiedzi",
				replies_many: "{{count}} odpowiedzi",
				question: "Pytanie #{{id}}",
				openQuestion: "Otwórz pytanie",
				deleteThread: "Usuń wątek",
				lastCommented: "Ostatnio skomentowane pytania",
				ai: {
					promptInfo:
						"Napisz, co chcesz odpowiedzieć, albo dodaj kontekst. Model zna pytanie, odpowiedzi, poprawną odpowiedź i komentarz. Możesz zostawić puste.",
					promptPlaceholder:
						"Np. podkreśl, że to zmiana w wytycznych z 2024 r.",
					generate: "Odpowiedz z AI",
					confirm: {
						title: "Zastąpić treść odpowiedzi?",
						subtitle:
							"Obecna treść odpowiedzi zostanie zastąpiona odpowiedzią AI.",
					},
				},
			},
			revealAnswers: "Pokaż poprawne odpowiedzi",
			discussion: {
				edit: "Edytuj omówienie",
				content: "Omówienie",
				save: "Zapisz omówienie",
				saveSuccess: "Omówienie zostało zapisane",
				writeOwn: "Napisz autorskie",
				deleteOwn: "Usuń autorskie",
				deleteSuccess: "Omówienie autorskie zostało usunięte",
				deleteConfirm: {
					title: "Usunąć omówienie autorskie?",
					subtitle:
						"Omówienie i źródła zostaną usunięte. W PES w ich miejscu pokaże się omówienie RAG, jeśli istnieje.",
				},
				type: { own: "Własne", rag: "RAG" },
				rag: {
					generate: "Wygeneruj RAG",
					tab: "Omówienie RAG",
					transferConfirm: {
						title: "Zastąpić treść omówienia?",
						subtitle:
							"Obecna treść omówienia i źródeł zostanie zastąpiona omówieniem RAG i cytowanymi w nim źródłami.",
					},
				},
				draftRestored: "Przywrócono niezapisany szkic z tej przeglądarki.",
				cancelConfirm: {
					title: "Odrzucić niezapisane zmiany?",
					subtitle:
						"Wprowadzone zmiany w omówieniu i źródłach zostaną utracone.",
				},
			},
			purchases: {
				title: "Raport zakupów",
				subtitle:
					"Opłacone zamówienia i przychód wg miesiąca i długości dostępu",
				superuserOnly: "Widoczne tylko dla superusera",
				tabs: {
					report: "Raport za okres",
					compare: "Porównanie okresów",
					reportHint: "sumy i tabela za wybrane miesiące",
					compareHint: "A vs B · pakiety, miesiące, specki",
				},
				grossHint:
					"kwoty brutto w zł, z faktycznie zapłaconej kwoty (po rabatach)",
				compare: {
					preset: {
						title: "Preset:",
						thisMonth: "Ten miesiąc vs poprzedni",
						thisYear: "Ten rok vs poprzedni",
						custom: "Własny zakres",
					},
					period: "Okres {{side}}",
					submit: "Porównaj",
					nextYear: "Ten sam okres B",
					toBeforeFrom: "Koniec nie może być przed początkiem",
					new: "nowe",
					partial: "dane do dziś",
					periodA: "okres A",
					soldB: "Sprzedane pakiety · B",
					soldHint: "tylko opłacone zamówienia",
					revenueB: "Przychód · B",
					revenueHint: "z faktycznie zapłaconej kwoty, nie z cennika",
					byDays: "Wg pakietu (długości dostępu)",
					columns: {
						package: "Pakiet",
						sold: "Sprzedane",
						change: "Zmiana",
						revenue: "Przychód",
						changeMoney: "Zmiana zł",
						units: "Sztuki",
					},
					total: "Razem",
					byMonth: "Wg miesiąca",
					byMonthHint: "· sztuki",
					bySpec: "Wg specjalizacji",
					pesOnly: "· tylko PES",
					empty: "Brak opłaconych zamówień w obu okresach",
					emptyHint: "Zmień okresy A i B.",
					footnote:
						"Pakiet = długość dostępu (days), jak w raporcie. Spadki na czerwono ze znakiem minus. Miesiące w UTC, tylko zamówienia opłacone (completed).",
				},
				filters: {
					from: "Od (miesiąc)",
					to: "Do (miesiąc)",
					toBeforeFrom: "„Do” nie może być przed „Od”",
					spec: "Specjalizacja",
					allSpecs: "Wszystkie specjalizacje",
					submit: "Pokaż raport",
				},
				range: {
					title: "Szybki zakres:",
					previousMonth: "Poprzedni miesiąc",
					last3Months: "Ostatnie 3 mies.",
					yearToDate: "Od początku roku",
					last12Months: "Ostatnie 12 mies.",
				},
				csv: "Pobierz CSV",
				csvDays: "Długość dostępu (dni)",
				csvRevenue: "Przychód (zł)",
				paidOrders: "Opłacone zamówienia",
				revenue: "Przychód",
				revenueHint: "brutto, z groszami",
				byDays: "Wg długości dostępu",
				byDaysHint: "za wybrany okres · zakupy · przychód · udział",
				days_one: "{{count}} dzień",
				days_few: "{{count}} dni",
				days_many: "{{count}} dni",
				columns: {
					spec: "Specjalizacja",
					month: "Miesiąc",
					days: "Długość dostępu",
					purchases: "Liczba zakupów",
					revenue: "Przychód",
				},
				view: {
					label: "Widok",
					spec: "Per specjalizacja",
					rows: "Wszystkie wiersze",
					month: "Per miesiąc",
				},
				monthTotal: "Razem {{month}}",
				periodTotal: "Razem za okres",
				rowsCount_one: "{{count}} wiersz",
				rowsCount_few: "{{count}} wiersze",
				rowsCount_many: "{{count}} wierszy",
				specCount_one: "{{count}} specjalizacja",
				specCount_few: "{{count}} specjalizacje",
				specCount_many: "{{count}} specjalizacji",
				empty: "Brak opłaconych zamówień w wybranym okresie",
				emptyHint: "Zmień zakres miesięcy.",
				emptyHintSpec:
					"Zmień zakres miesięcy albo wybierz „Wszystkie specjalizacje”.",
				footnote:
					"Miesiące liczone w UTC – zamówienie z 1. dnia między 00:00 a ok. 02:00 czasu polskiego trafia do poprzedniego miesiąca. Tylko zamówienia opłacone (completed). Miesiące bez zakupów nie pojawiają się w tabeli.",
			},
			users: {
				title: "Użytkownicy",
				sort: {
					title: "Sortowanie",
					newest: "Najnowsze konta",
					oldest: "Najstarsze konta",
					lastLoginDesc: "Ostatnio logowani",
					lastLoginAsc: "Najdawniej logowani",
					emailAsc: "E-mail A–Z",
					emailDesc: "E-mail Z–A",
					usernameAsc: "Login A–Z",
					usernameDesc: "Login Z–A",
				},
				search: "Szukaj po loginie, e-mailu, imieniu i nazwisku lub ID…",
				empty: "Brak użytkowników dla tych filtrów",
				found: "Znaleziono {{total}}",
				pageOf: "strona {{page}} z {{pages}}",
				banned: "Zablokowane komentarze",
				copied: "Skopiowano: {{value}}",
				clickToCopy: "Kliknij, żeby skopiować",
				login: "login",
				email: "e-mail",
				back: "Wróć",
				backToList: "Wróć do listy",
				notFound: "Nie ma użytkownika o id {{id}}",
				columns: {
					user: "Użytkownik",
					id: "ID",
					access: "Dostęp",
					lek: "Dostęp LEK",
					pes: "Dostęp PES",
					email: "E-mail",
					name: "Imię i nazwisko",
					spec: "Specjalizacja PES",
					lastLogin: "Ostatnie logowanie",
					joined: "Rejestracja",
				},
				filters: {
					access: "Dostęp",
					all: "Wszyscy",
					withAccess: "Z aktywnym dostępem",
					withoutAccess: "Bez aktywnego dostępu",
					product: "Produkt",
					bothProducts: "Oba",
					onlyLek: "Tylko LEK",
					onlyPes: "Tylko PES",
					account: "Konto",
					onlyStaff: "Tylko staff",
					banned: "Zablokowane komentarze",
					spec: "Aktualna specjalizacja PES",
					allSpecs: "Wszystkie",
				},
				access: {
					title: "Dostępy",
					until: "do {{date}}",
					expired: "wygasł {{date}}",
					active: "aktywny",
					never: "nigdy",
					lifetime: "bezterminowo",
					statusActive: "Aktywny",
					statusExpired: "Wygasł",
					empty: "Brak dostępów",
					extra: "Pytania dodatkowe",
					extraShort: "Dodatk.",
					lekScope: "Pytania, omówienia, artykuły",
					wholeProduct: "Cały produkt",
					activeCount_one: "{{count}} aktywny",
					activeCount_few: "{{count}} aktywne",
					activeCount_many: "{{count}} aktywnych",
					expiredCount_one: "{{count}} wygasły",
					expiredCount_few: "{{count}} wygasłe",
					expiredCount_many: "{{count}} wygasłych",
					source: {
						userinfo: "data na koncie",
						specialization: "zakup specjalizacji",
						legacy: "stary pakiet",
					},
					extend: {
						title: "Przedłuż dostęp",
						submit: "Przedłuż",
						currentUntil: "obecnie do {{date}}",
						newDate: "Nowa data końca",
						plusDays_one: "+{{count}} dzień",
						plusDays_few: "+{{count}} dni",
						plusDays_many: "+{{count}} dni",
						coveredByPes:
							"Cały PES jest ważny i przykrywa tę datę — user zobaczy ją dopiero po wygaśnięciu całego PES.",
					},
					grant: {
						title: "Nadaj dostęp",
						product: "Produkt",
						specs: "Specjalizacje PES",
						addSpec: "Dodaj specjalizację…",
						specRequired: "Wybierz specjalizację albo „Wszystkie”",
						until: "Dostęp do",
					},
					renew: {
						title: "Odnów dostęp",
						submit: "Odnów",
					},
				},
				ban: {
					ban: "Zbanuj",
					unban: "Odbanuj",
					banTitle: "Zbanować {{name}}?",
					unbanTitle: "Odbanować {{name}}?",
					banWarning:
						"User nie będzie mógł pisać komentarzy. Możesz to cofnąć w każdej chwili.",
					unbanWarning: "User znowu będzie mógł pisać komentarze.",
					banned: "Zbanowano.",
					unbanned: "Odbanowano.",
				},
				account: {
					title: "Konto",
					joined: "Rejestracja",
					lastLogin: "Ostatnie logowanie",
					banned: "Zbanowany",
					active: "Konto aktywne",
					service: "Serwis",
				},
				orders: {
					title: "Zamówienia",
					paidSum: "suma opłaconych {{sum}}",
					empty: "Brak zamówień",
					id: "Nr",
					date: "Data",
					price: "Kwota",
					days: "Okres",
					daysCount_one: "{{count}} dzień",
					daysCount_few: "{{count}} dni",
					daysCount_many: "{{count}} dni",
					product: "Produkt",
					source: "Źródło",
					invoice: "Faktura",
					noInvoice: "brak faktury",
					status: {
						title: "Status",
						completed: "Opłacone",
						processing: "Nieopłacone",
						rejected: "Odrzucone",
					},
				},
			},
			logs: {
				title: "Historia zmian",
				subtitle:
					"Każda zmiana z panelu admina i starego Django admin (od 2017) · tylko superuser · czas lokalny",
				search:
					"Szukaj po opisie obiektu (np. /admin/articles/12, „pytanie”) lub ID obiektu…",
				empty: "Brak wpisów dla tych filtrów",
				object: "Obiekt",
				deletedAccount: "konto usunięte",
				djangoSource: "{{type}} · stary Django admin",
				changedFields: "Zmienione pola: {{fields}}",
				questionHistory: "Historia zmian tego pytania",
				articleHistory: "Historia zmian tego artykułu",
				columns: {
					time: "Kiedy",
					action: "Akcja",
					user: "Kto",
					object: "Obiekt",
					change: "Co się zmieniło",
				},
				action: {
					added: "Dodano",
					changed: "Zmieniono",
					deleted: "Usunięto",
				},
				period: {
					today: "Dziś",
					yesterday: "Wczoraj",
					"7d": "7 dni",
					"30d": "30 dni",
					month: "Ten miesiąc",
					all: "Wszystko",
				},
				filters: {
					period: "Okres",
					from: "Od",
					to: "Do",
					action: "Akcja",
					user: "Kto zmienił",
					type: "Typ obiektu",
					objectId: "ID obiektu",
					objectIdPlaceholder: "np. 12",
				},
				details: {
					title: "Szczegóły wpisu",
					id: "ID wpisu",
					utc: "Czas (UTC)",
					admin: "Admin",
					type: "Typ obiektu",
					objectId: "ID obiektu",
					raw: "Change message (surowe)",
					note: "Historia mówi, które pola zmieniono, bez wartości „z czego na co”.",
					open: "Otwórz {{object}}",
				},
				types: {
					questionLek: "Pytanie LEK",
					questionPes: "Pytanie PES",
					questionLdek: "Pytanie LDEK",
					questionPesDjango: "Pytanie PES (Django)",
					questionLekDjango: "Pytanie LEK (Django)",
					articleDjango: "Artykuł (Django)",
					article: "Artykuł",
					articleCategory: "Kategoria artykułów",
					articleTag: "Tag artykułów",
					blogPost: "Wpis bloga",
					blogTag: "Tag bloga",
					user: "Użytkownik",
					group: "Grupa uprawnień",
					permission: "Uprawnienie",
					image: "Obrazek",
					notification: "Powiadomienie",
					admin: "Akcja w panelu",
				},
			},
			textStyles: {
				title: "Style tekstu",
				sections: {
					headings: "Nagłówki",
					paragraph: "Akapit i formatowanie",
					colors: "Kolory tekstu",
					highlights: "Podświetlenia",
					align: "Wyrównanie",
					bulletList: "Lista punktowana",
					orderedList: "Lista numerowana",
					taskList: "Lista zadań",
					callouts: "Alerty",
					blockquote: "Cytat",
					codeBlock: "Blok kodu",
					table: "Tabela",
					tableFigure: "Tabela z tytułem i legendą",
					image: "Obrazek",
					imageCaption: "Obrazek z podpisem",
					hr: "Linia pozioma",
				},
			},
			navbar: {
				badge: {
					short: "Admin",
					label: "Panel",
					title: "Administracja",
				},
				comments: "Komentarze",
				logs: "Historia zmian",
				purchases: "Raport zakupów",
				groups: {
					stats: "Statystyki",
					users: "Użytkownicy",
					ai: "AI",
					content: "Kontent",
					blog: "Blog",
				},
				blogPosts: "Wpisy",
				blogTags: "Tagi",
				articleCategories: "Kategorie",
				usersList: "Użytkownicy",
				permissions: "Uprawnienia",
				home: "Start",
				uploadImage: "Obrazki",
				textStyles: "Style tekstu",
				aiChat: "Czat AI",
				guide: "Poradnik",
				questions: "Pytania",
				articles: "Artykuły",
				decks: "Fiszki",
				notifications: "Powiadomienia",
			},
			notifications: {
				viewOnly:
					"Masz tylko podgląd – wysyłka wymaga zapisu w sekcji Powiadomienia.",
				title: "Nowe powiadomienie",
				service: "Serwis",
				specs: "Specjalizacje",
				specsPlaceholder: "Wybierz specjalizacje",
				allSpecs: "Wszystkie specjalizacje",
				noSpecs: "Brak wyników",
				type: "Rodzaj",
				types: {
					info: "Komunikat",
					link: "Link zewnętrzny",
					localLink: "Link w aplikacji",
				},
				url: "Adres URL",
				localUrl: "Ścieżka w aplikacji",
				message: "Treść",
				messagePlaceholder: "Treść powiadomienia…",
				endDate: "Ważne do",
				summary: "{{audience}} · ważne do {{date}}",
				sent_one: "Wysłano {{count}} powiadomienie.",
				sent_few: "Wysłano {{count}} powiadomienia.",
				sent_many: "Wysłano {{count}} powiadomień.",
				sendFailed:
					"Nie wysłano {{failed}} z {{total}} powiadomień: {{message}}",
				errors: {
					specs: "Wybierz specjalizacje albo zaznacz „Wszystkie”.",
					externalUrl: "Link zewnętrzny musi zaczynać się od https://",
					localUrl: "Ścieżka musi zaczynać się od /",
					message: "Treść nie może być pusta.",
					endDate: "Data musi być w przyszłości.",
				},
				confirm: {
					title: "Wysłać powiadomienie?",
					warning: "Nie da się go cofnąć ani edytować. Zniknie samo {{date}}.",
				},
				preview: {
					title: "Podgląd",
					description:
						"Tak użytkownik zobaczy powiadomienie po kliknięciu dzwonka.",
					placeholder: "Treść powiadomienia pojawi się tutaj.",
					audience: "Do kogo",
					link: "Link",
					expires: "Znika",
				},
			},
			permissions: {
				retry: "Spróbuj ponownie",
				unsaved: "Masz niezapisane zmiany",
				unsavedPrompt: "Masz niezapisane zmiany. Wyjść bez zapisu?",
				saveFailed:
					"Nie udało się zapisać. Twoje zmiany są nadal w formularzu.",
				codesCount_one: "{{count}} kod",
				codesCount_few: "{{count}} kody",
				codesCount_many: "{{count}} kodów",
				codes: {
					add: "Dodaj uprawnienie",
					remove: "Usuń {{code}}",
				},
				picker: {
					search: "Szukaj po kodzie lub nazwie…",
					given: "nadane",
					footer: "{{shown}} z {{total}} kodów · Enter dodaje, Esc zamyka",
				},
				grant: {
					search: "Szukaj obszaru…",
					remove: "Odbierz bezpośredni dostęp",
				},
				pickArea: {
					title: "Dodaj obszar",
					search: "Szukaj obszaru po nazwie lub kodzie…",
					count: "{{shown}} z {{total}} obszarów",
					countFor: "{{shown}} z {{total}} obszarów dla „{{search}}”",
					alreadySet: "ustawione: {{level}}",
					done: "Gotowe",
					toGroup: "do grupy",
					toNewGroup: "do nowej grupy",
					directFor: "bezpośrednio dla",
					outsideGroups: "poza grupami",
					hint: "Kliknij Odczyt albo Zapis przy obszarach, potem „Gotowe”",
					pickedCount_one: "Wybrano {{count}} obszar",
					pickedCount_few: "Wybrano {{count}} obszary",
					pickedCount_many: "Wybrano {{count}} obszarów",
					superuserOnly: "tylko superuser",
				},
				addStaff: {
					title: "Dodaj do staffu",
					description:
						"Staff daje dostęp do panelu admina. Co osoba może w nim robić, ustawiasz grupami i uprawnieniami.",
					search: "Szukaj konta po imieniu, e-mailu lub loginie…",
					minChars: "Wpisz co najmniej 3 znaki.",
					grant: "Nadaj staff",
					granted: "Nadano staff. Zmiana zadziała w ciągu 30 s.",
				},
				revokeStaff: {
					action: "Odbierz staff",
					title: "Odebrać staff: {{name}}?",
					warning:
						"Osoba straci dostęp do panelu. Grupy i uprawnienia zostają, ale przestaną działać.",
					done: "Odebrano staff. Zmiana zadziała w ciągu 30 s.",
				},
				readOnly: {
					panelGroup:
						"Tylko do odczytu – grupa daje dostęp do panelu, zmienia ją tylko superuser.",
					noWrite:
						"Tylko do odczytu – nie masz prawa zapisu w panelu uprawnień.",
				},
				superuser: {
					grant: "Nadaj superadmina",
					revoke: "Odbierz superadmina",
					grantTitle: "Nadać superadmina: {{name}}?",
					revokeTitle: "Odebrać superadmina: {{name}}?",
					granted: "Nadano superadmina.",
					revoked: "Odebrano superadmina.",
					grantWarning:
						"Superadmin ma pełny dostęp do wszystkich obszarów i do panelu uprawnień, niezależnie od grup. Nadanie ustawia też staff.",
					revokeWarning:
						"Osoba straci pełny dostęp. Zostanie jej staff, grupy i uprawnienia nadane bezpośrednio.",
				},
				userGroups: {
					add: "Dodaj do grupy",
					remove: "Usuń z grupy",
					none: "Nie należy do żadnej grupy.",
					for: "dla",
					pickedCount_one: "Wybrano {{count}} grupę",
					pickedCount_few: "Wybrano {{count}} grupy",
					pickedCount_many: "Wybrano {{count}} grup",
				},
				level: {
					none: "Brak",
					read: "Odczyt",
					write: "Zapis",
				},
				tabs: {
					groups: "Grupy",
					areas: "Uprawnienia",
					users: "Użytkownicy",
					groupsCount_one: "{{count}} grupa",
					groupsCount_few: "{{count}} grupy",
					groupsCount_many: "{{count}} grup",
					areasCount_one: "{{count}} obszar",
					areasCount_few: "{{count}} obszary",
					areasCount_many: "{{count}} obszarów",
					usersCount_one: "{{count}} osoba staff",
					usersCount_few: "{{count}} osoby staff",
					usersCount_many: "{{count}} osób staff",
				},
				forbidden: {
					title: "Brak dostępu do uprawnień",
					description:
						"Nie masz dostępu do panelu uprawnień. Poproś superusera o obszar „Panel uprawnień”.",
					back: "Wróć do panelu admina",
				},
				unsavedModal: {
					title: "Niezapisane zmiany",
					group:
						"Masz niezapisane zmiany w grupie {{name}}. Jeśli przejdziesz dalej bez zapisu, przepadną.",
					user: "Masz niezapisane zmiany u użytkownika {{name}}. Jeśli przejdziesz dalej bez zapisu, przepadną.",
					discard: "Odrzuć zmiany",
					back: "Wróć do edycji",
					save: "Zapisz i przejdź",
				},
				groups: {
					emptyTitle: "Brak wybranej grupy",
					emptyDescription:
						"Utwórz pierwszą grupę przyciskiem „Nowa grupa” i nadaj jej poziomy dostępu do obszarów.",
					search: "Szukaj grupy…",
					none: "Nie ma jeszcze żadnej grupy.",
					areasCount_one: "{{count}} obszar",
					areasCount_few: "{{count}} obszary",
					areasCount_many: "{{count}} obszarów",
					membersCount_one: "{{count}} osoba",
					membersCount_few: "{{count}} osoby",
					membersCount_many: "{{count}} osób",
				},
				group: {
					levels: "Poziom dostępu do obszarów",
					writeIncludesRead:
						"Zapis zawiera odczyt · obszary spoza listy dodasz przez „Dodaj obszar”",
					saveHint:
						"Zapis podmienia uprawnienia grupy; kody Django przechodzą bez zmian",
					saved: "Zapisano grupę.",
					delete: "Usuń grupę",
					deleteTitle: "Usunąć grupę {{name}}?",
					deleted: "Usunięto grupę.",
					deleteWarning_one:
						"Znikną jej uprawnienia, a {{count}} osoba straci dostęp nadany przez tę grupę. Nie da się tego cofnąć.",
					deleteWarning_few:
						"Znikną jej uprawnienia, a {{count}} osoby stracą dostęp nadany przez tę grupę. Nie da się tego cofnąć.",
					deleteWarning_many:
						"Znikną jej uprawnienia, a {{count}} osób straci dostęp nadany przez tę grupę. Nie da się tego cofnąć.",
				},
				newGroup: {
					title: "Nowa grupa",
					name: "Nazwa grupy",
					submit: "Utwórz grupę",
					exists: "Grupa o tej nazwie już istnieje.",
				},
				members: {
					picked: "Wybrano",
					pickedCount_one: "Wybrano {{count}} osobę",
					pickedCount_few: "Wybrano {{count}} osoby",
					pickedCount_many: "Wybrano {{count}} osób",
					title: "Osoby w grupie",
					add: "Dodaj użytkownika",
					remove: "Usuń z grupy",
					already: "już w grupie",
					empty: "Nikt nie jest w tej grupie",
					emptyHint:
						"Dodaj osoby ze staffu – grupa działa tylko u osób z dostępem do panelu.",
					staffOnly: "Tylko osoby ze staffem – bez niego grupy nie zadziałają.",
					notStaff: "Do grupy można dodać tylko osobę ze staffem.",
				},
				areas: {
					title: "Obszary",
					description:
						"Obszar to para kodów: view_ (odczyt) i change_ (zapis). Własne obszary dodajesz tutaj, modele starego panelu Django są tu automatycznie.",
					area: "Obszar",
					codes: "Kody",
					usedIn: "Używany w grupach",
					unused: "nieużywany",
					none: "Nie ma jeszcze żadnego obszaru.",
					empty: "Nie ma jeszcze obszarów. Dodaj je w zakładce Uprawnienia.",
					codesHint: "{{read}} → odczyt, {{write}} → zapis",
					custom: "własny",
					remove: "Usuń obszar",
					removeHint: "× usuwa obszar (poziom „Brak”)",
					noneAssigned: "Brak przypisanych obszarów.",
				},
				addArea: {
					title: "Dodaj obszar",
					label: "Nazwa wyświetlana",
					key: "Klucz obszaru",
					keyFormat: "Tylko małe litery a–z, cyfry i _",
					codes: "Zostaną utworzone 2 kody:",
					submit: "Utwórz obszar",
					exists: "Obszar o tym kluczu już istnieje.",
				},
				users: {
					actions: "Akcje",
					sourceGroup: "grupa",
					sourceDirect: "uprawnienie",
					emptyTitle: "Brak wybranej osoby",
					emptyDescription:
						"Wybierz osobę z listy, żeby zobaczyć i zmienić jej grupy.",
					staffOnly: "tylko staff",
					search: "Szukaj po imieniu lub e-mailu…",
					noResults: "Brak wyników dla „{{search}}”",
					noResultsHint:
						"Szukamy tylko wśród osób ze staffem. Inne konto dodasz przez „Dodaj do staffu”.",
					badge: {
						staff: "Staff",
						superuser: "Superuser",
						inactive: "Nieaktywny",
					},
					superuser: "Superuser – pełny dostęp do wszystkich obszarów",
					superuserNote: "Grupy nie mają dla tego konta znaczenia.",
					inactive:
						"Konto nieaktywne – użytkownik nie ma żadnych uprawnień, nawet z grup.",
					noAreas: "bez obszarów",
					effective: "Efektywne uprawnienia",
					preview: "podgląd po zapisie",
					level: "Poziom",
					source: "Źródło",
					changed: "zmiana",
					fromGroups_one: "z grupy: {{groups}}",
					fromGroups_few: "z grup: {{groups}}",
					fromGroups_many: "z grup: {{groups}}",
					direct: "bezpośrednio",
					directTitle: "Inne uprawnienia nadane bezpośrednio (Django)",
					directNote:
						"Kody spoza obszarów. Ta sama lista co „User permissions” w Django admin – zmiany widać tam od razu.",
					saveHint: "Zapis obejmuje grupy i uprawnienia nadane bezpośrednio",
					save: "Zapisz grupy",
					saved: "Zapisano zmiany.",
					saveFailed: "Nie udało się zapisać zmian",
					saveFailedDetails:
						"Serwer odpowiedział {{status}}. Twoje zmiany są nadal w formularzu.",
					noGroups: "Nie ma jeszcze grup.",
					goToGroups: "Przejdź do zakładki Grupy",
					noAreasDefined: "Nie zdefiniowano obszarów.",
					goToAreas: "Przejdź do zakładki Uprawnienia",
					noAccess: "Brak dostępu do żadnego obszaru.",
					changeInGroup: "zmień w grupie",
					directHint:
						"Dodaje uprawnienie bezpośrednio na koncie (jak „User permissions” w Django). × usuwa.",
					editable: "edytowalne",
					effectiveHint: "z grup i nadane bezpośrednio",
				},
			},
			section: {
				deniedTitle: "Brak dostępu do tej sekcji",
				deniedDescription:
					"Poproś osobę z panelu uprawnień o dostęp do tej części panelu admina.",
			},
			accessDenied: {
				title: "Brak uprawnień",
				description: "To konto nie ma dostępu do panelu administracyjnego.",
				logout: "Wyloguj się",
			},
			notFound: {
				title: "Nie ma takiej strony",
				back: "Wróć na start",
			},
		},
	},
};

export { pl };
